webpackJsonp([213534597649335],{

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _polylinearScale = __webpack_require__(486);
	
	var _polylinearScale2 = _interopRequireDefault(_polylinearScale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var transformUnits = {
	  perspective: 'px',
	  rotate: 'deg',
	  rotateX: 'deg',
	  rotateY: 'deg',
	  rotateZ: 'deg',
	  scale: '',
	  scaleX: '',
	  scaleY: '',
	  scaleZ: '',
	  skew: 'deg',
	  skewX: 'deg',
	  skewY: 'deg',
	  translateX: 'px',
	  translateY: 'px',
	  translateZ: 'px'
	};
	var transformKeys = Object.keys(transformUnits);
	
	var AnimationBus = function () {
	  function AnimationBus(_ref) {
	    var animations = _ref.animations,
	        element = _ref.element,
	        origin = _ref.origin;
	
	    _classCallCheck(this, AnimationBus);
	
	    this.animations = animations;
	    this.element = element;
	    this.origin = origin;
	  }
	
	  _createClass(AnimationBus, [{
	    key: 'getStyles',
	    value: function getStyles() {
	      var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.element;
	
	      var origin = this.origin(element);
	      var transformValues = [];
	      var styles = {};
	
	      this.animations.forEach(function (animation) {
	        var prop = animation.prop;
	        var unit = animation.unit || transformUnits[prop] || '';
	        var value = (0, _polylinearScale2.default)(animation.stops)(origin);
	
	        if (transformKeys.indexOf(prop) > -1) {
	          transformValues.push(prop + '(' + value + unit + ')');
	        } else {
	          styles[prop] = '' + value + unit;
	        }
	      });
	
	      if (transformValues.length) {
	        styles.transform = transformValues.join(' ');
	      }
	
	      return styles;
	    }
	  }, {
	    key: 'applyStyles',
	    value: function applyStyles() {
	      var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.element;
	
	      var styles = this.getStyles(element);
	      Object.keys(styles).forEach(function (key) {
	        return element.style[key] = styles[key];
	      });
	    }
	  }]);
	
	  return AnimationBus;
	}();
	
	exports.default = AnimationBus;
	module.exports = exports['default'];

/***/ }),

/***/ 485:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = piecewise;
	function piecewise(xs, ys) {
	  return function (x) {
	    // out of bounds
	    if (x <= xs[0]) {
	      return ys[0];
	    } else if (x >= xs[xs.length - 1]) {
	      return ys[xs.length - 1];
	    }
	
	    // bisect
	    var lo = 0;
	    var hi = xs.length - 1;
	
	    while (hi - lo > 1) {
	      var mid = lo + hi >> 1;
	      if (x < xs[mid]) {
	        hi = mid;
	      } else {
	        lo = mid;
	      }
	    }
	
	    // project
	    return ys[lo] + (ys[hi] - ys[lo]) / (xs[hi] - xs[lo]) * (x - xs[lo]);
	  };
	}
	module.exports = exports["default"];

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = polylinearScale;
	
	var _piecewise = __webpack_require__(485);
	
	var _piecewise2 = _interopRequireDefault(_piecewise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function polylinearScale(stops) {
	  var xs = [];
	  var ys_r = [];
	  var ys_g = [];
	  var ys_b = [];
	
	  stops.forEach(function (_ref) {
	    var _ref2 = _slicedToArray(_ref, 2),
	        domain = _ref2[0],
	        range = _ref2[1];
	
	    xs.push(domain);
	    if (isNaN(range)) {
	      ys_r.push(parseInt(range.substr(1, 2), 16));
	      ys_g.push(parseInt(range.substr(3, 2), 16));
	      ys_b.push(parseInt(range.substr(5, 2), 16));
	    } else {
	      ys_r.push(range);
	    }
	  });
	
	  var pw_r = (0, _piecewise2.default)(xs, ys_r);
	
	  if (ys_g.length && ys_b.length) {
	    var _ret = function () {
	      var pw_g = (0, _piecewise2.default)(xs, ys_g);
	      var pw_b = (0, _piecewise2.default)(xs, ys_b);
	      return {
	        v: function v(x) {
	          return 'rgb(' + Math.round(pw_r(x)) + ', ' + Math.round(pw_g(x)) + ', ' + Math.round(pw_b(x)) + ')';
	        }
	      };
	    }();
	
	    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	  } else {
	    return function (x) {
	      return pw_r(x);
	    };
	  }
	}
	module.exports = exports['default'];

/***/ }),

/***/ 722:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = getPrefix;
	
	function getPrefix(prop) {
	  if (typeof document === 'undefined') return prop;
	
	  var styles = document.createElement('p').style;
	  var vendors = ['ms', 'O', 'Moz', 'Webkit'];
	
	  if (styles[prop] === '') return prop;
	
	  prop = prop.charAt(0).toUpperCase() + prop.slice(1);
	
	  for (var i = vendors.length; i--;) {
	    if (styles[vendors[i] + prop] === '') {
	      return vendors[i] + prop;
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 269:
/***/ (function(module, exports) {

	function n(n){return n=n||Object.create(null),{on:function(c,e){(n[c]||(n[c]=[])).push(e)},off:function(c,e){n[c]&&n[c].splice(n[c].indexOf(e)>>>0,1)},emit:function(c,e){(n[c]||[]).slice().map(function(n){n(e)}),(n["*"]||[]).slice().map(function(n){n(c,e)})}}}module.exports=n;
	//# sourceMappingURL=mitt.js.map

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
	(function() {
	  var getNanoSeconds, hrtime, loadTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - loadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    loadTime = getNanoSeconds();
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(77)))

/***/ }),

/***/ 77:
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(871)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 871:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(77)))

/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.FadeIn = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLazyload = __webpack_require__(124);
	
	var _reactLazyload2 = _interopRequireDefault(_reactLazyload);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactTransitionGroup = __webpack_require__(305);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var duration = 500;
	
	var defaultStyle = {
	    transition: "opacity " + duration + "ms ease-in-out",
	    opacity: 0,
	    display: "inline-block"
	};
	
	var transitionStyles = {
	    entering: { opacity: 0 },
	    entered: { opacity: 1 }
	};
	
	var FadeIn = function (_React$Component) {
	    _inherits(FadeIn, _React$Component);
	
	    function FadeIn() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, FadeIn);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	            loaded: false
	        }, _this.onLoad = function () {
	            return _this.setState({ loaded: true });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    FadeIn.prototype.render = function render() {
	        var _this2 = this;
	
	        var _props = this.props,
	            height = _props.height,
	            children = _props.children,
	            render = _props.render,
	            offset = _props.offset,
	            restProps = _objectWithoutProperties(_props, ["height", "children", "render", "offset"]),
	            loaded = this.state.loaded;
	
	        return _react2.default.createElement(
	            _reactLazyload2.default,
	            _extends({
	                height: height,
	                offset: typeof offset === "undefined" ? 150 : offset
	            }, restProps),
	            _react2.default.createElement(
	                _reactTransitionGroup.Transition,
	                { "in": loaded, timeout: duration },
	                function (state) {
	                    return _react2.default.createElement(
	                        "div",
	                        {
	                            style: _extends({}, defaultStyle, transitionStyles[state])
	                        },
	                        children && children(_this2.onLoad),
	                        render && render(_this2.onLoad)
	                    );
	                }
	            )
	        );
	    };
	
	    return FadeIn;
	}(_react2.default.Component);
	
	FadeIn.propTypes =  false ? {
	    height: _propTypes2.default.number,
	    children: _propTypes2.default.func,
	    render: _propTypes2.default.func
	} : {};
	
	exports.FadeIn = FadeIn;
	exports.default = FadeIn;

/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.FadeIn = undefined;
	
	var _FadeIn = __webpack_require__(276);
	
	var _FadeIn2 = _interopRequireDefault(_FadeIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FadeIn2.default;
	exports.FadeIn = _FadeIn2.default;

/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(124);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDisplayName = function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	};
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return function lazyload(WrappedComponent) {
	    return function (_Component) {
	      _inherits(LazyLoadDecorated, _Component);
	
	      function LazyLoadDecorated() {
	        _classCallCheck(this, LazyLoadDecorated);
	
	        var _this = _possibleConstructorReturn(this, (LazyLoadDecorated.__proto__ || Object.getPrototypeOf(LazyLoadDecorated)).call(this));
	
	        _this.displayName = 'LazyLoad' + getDisplayName(WrappedComponent);
	        return _this;
	      }
	
	      _createClass(LazyLoadDecorated, [{
	        key: 'render',
	        value: function render() {
	          return _react2.default.createElement(
	            _index2.default,
	            options,
	            _react2.default.createElement(WrappedComponent, this.props)
	          );
	        }
	      }]);
	
	      return LazyLoadDecorated;
	    }(_react.Component);
	  };
	};

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.forceCheck = exports.lazyload = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(25);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _event = __webpack_require__(279);
	
	var _scrollParent = __webpack_require__(280);
	
	var _scrollParent2 = _interopRequireDefault(_scrollParent);
	
	var _debounce = __webpack_require__(278);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _throttle = __webpack_require__(281);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _decorator = __webpack_require__(277);
	
	var _decorator2 = _interopRequireDefault(_decorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * react-lazyload
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var defaultBoundingClientRect = { top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 };
	var LISTEN_FLAG = 'data-lazyload-listened';
	var listeners = [];
	var pending = [];
	
	// try to handle passive events
	var passiveEventSupported = false;
	try {
	  var opts = Object.defineProperty({}, 'passive', {
	    get: function get() {
	      passiveEventSupported = true;
	    }
	  });
	  window.addEventListener('test', null, opts);
	} catch (e) {}
	// if they are supported, setup the optional params
	// IMPORTANT: FALSE doubles as the default CAPTURE value!
	var passiveEvent = passiveEventSupported ? { capture: false, passive: true } : false;
	
	/**
	 * Check if `component` is visible in overflow container `parent`
	 * @param  {node} component React component
	 * @param  {node} parent    component's scroll parent
	 * @return {bool}
	 */
	var checkOverflowVisible = function checkOverflowVisible(component, parent) {
	  var node = _reactDom2.default.findDOMNode(component);
	
	  var parentTop = void 0;
	  var parentHeight = void 0;
	
	  try {
	    var _parent$getBoundingCl = parent.getBoundingClientRect();
	
	    parentTop = _parent$getBoundingCl.top;
	    parentHeight = _parent$getBoundingCl.height;
	  } catch (e) {
	    parentTop = defaultBoundingClientRect.top;
	    parentHeight = defaultBoundingClientRect.height;
	  }
	
	  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
	
	  // calculate top and height of the intersection of the element's scrollParent and viewport
	  var intersectionTop = Math.max(parentTop, 0); // intersection's top relative to viewport
	  var intersectionHeight = Math.min(windowInnerHeight, parentTop + parentHeight) - intersectionTop; // height
	
	  // check whether the element is visible in the intersection
	  var top = void 0;
	  var height = void 0;
	
	  try {
	    var _node$getBoundingClie = node.getBoundingClientRect();
	
	    top = _node$getBoundingClie.top;
	    height = _node$getBoundingClie.height;
	  } catch (e) {
	    top = defaultBoundingClientRect.top;
	    height = defaultBoundingClientRect.height;
	  }
	
	  var offsetTop = top - intersectionTop; // element's top relative to intersection
	
	  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API
	
	  return offsetTop - offsets[0] <= intersectionHeight && offsetTop + height + offsets[1] >= 0;
	};
	
	/**
	 * Check if `component` is visible in document
	 * @param  {node} component React component
	 * @return {bool}
	 */
	var checkNormalVisible = function checkNormalVisible(component) {
	  var node = _reactDom2.default.findDOMNode(component);
	
	  // If this element is hidden by css rules somehow, it's definitely invisible
	  if (!(node.offsetWidth || node.offsetHeight || node.getClientRects().length)) return false;
	
	  var top = void 0;
	  var elementHeight = void 0;
	
	  try {
	    var _node$getBoundingClie2 = node.getBoundingClientRect();
	
	    top = _node$getBoundingClie2.top;
	    elementHeight = _node$getBoundingClie2.height;
	  } catch (e) {
	    top = defaultBoundingClientRect.top;
	    elementHeight = defaultBoundingClientRect.height;
	  }
	
	  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
	
	  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API
	
	  return top - offsets[0] <= windowInnerHeight && top + elementHeight + offsets[1] >= 0;
	};
	
	/**
	 * Detect if element is visible in viewport, if so, set `visible` state to true.
	 * If `once` prop is provided true, remove component as listener after checkVisible
	 *
	 * @param  {React} component   React component that respond to scroll and resize
	 */
	var checkVisible = function checkVisible(component) {
	  var node = _reactDom2.default.findDOMNode(component);
	  if (!node) {
	    return;
	  }
	
	  var parent = (0, _scrollParent2.default)(node);
	  var isOverflow = component.props.overflow && parent !== node.ownerDocument && parent !== document && parent !== document.documentElement;
	  var visible = isOverflow ? checkOverflowVisible(component, parent) : checkNormalVisible(component);
	  if (visible) {
	    // Avoid extra render if previously is visible
	    if (!component.visible) {
	      if (component.props.once) {
	        pending.push(component);
	      }
	
	      component.visible = true;
	      component.forceUpdate();
	    }
	  } else if (!(component.props.once && component.visible)) {
	    component.visible = false;
	    if (component.props.unmountIfInvisible) {
	      component.forceUpdate();
	    }
	  }
	};
	
	var purgePending = function purgePending() {
	  pending.forEach(function (component) {
	    var index = listeners.indexOf(component);
	    if (index !== -1) {
	      listeners.splice(index, 1);
	    }
	  });
	
	  pending = [];
	};
	
	var lazyLoadHandler = function lazyLoadHandler() {
	  for (var i = 0; i < listeners.length; ++i) {
	    var listener = listeners[i];
	    checkVisible(listener);
	  }
	  // Remove `once` component in listeners
	  purgePending();
	};
	
	// Depending on component's props
	var delayType = void 0;
	var finalLazyLoadHandler = null;
	
	var LazyLoad = function (_Component) {
	  _inherits(LazyLoad, _Component);
	
	  function LazyLoad(props) {
	    _classCallCheck(this, LazyLoad);
	
	    var _this = _possibleConstructorReturn(this, (LazyLoad.__proto__ || Object.getPrototypeOf(LazyLoad)).call(this, props));
	
	    _this.visible = false;
	    return _this;
	  }
	
	  _createClass(LazyLoad, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (typeof process !== 'undefined' && ("production") !== 'production') {
	        if (_react2.default.Children.count(this.props.children) > 1) {
	          console.warn('[react-lazyload] Only one child is allowed to be passed to `LazyLoad`.');
	        }
	
	        if (this.props.wheel) {
	          // eslint-disable-line
	          console.warn('[react-lazyload] Props `wheel` is not supported anymore, try set `overflow` for lazy loading in overflow containers.');
	        }
	
	        // Warn the user if placeholder and height is not specified and the rendered height is 0
	        if (!this.props.placeholder && this.props.height === undefined && _reactDom2.default.findDOMNode(this).offsetHeight === 0) {
	          console.warn('[react-lazyload] Please add `height` props to <LazyLoad> for better performance.');
	        }
	      }
	
	      // It's unlikely to change delay type on the fly, this is mainly
	      // designed for tests
	      var needResetFinalLazyLoadHandler = false;
	      if (this.props.debounce !== undefined && delayType === 'throttle') {
	        console.warn('[react-lazyload] Previous delay function is `throttle`, now switching to `debounce`, try setting them unanimously');
	        needResetFinalLazyLoadHandler = true;
	      } else if (delayType === 'debounce' && this.props.debounce === undefined) {
	        console.warn('[react-lazyload] Previous delay function is `debounce`, now switching to `throttle`, try setting them unanimously');
	        needResetFinalLazyLoadHandler = true;
	      }
	
	      if (needResetFinalLazyLoadHandler) {
	        (0, _event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
	        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
	        finalLazyLoadHandler = null;
	      }
	
	      if (!finalLazyLoadHandler) {
	        if (this.props.debounce !== undefined) {
	          finalLazyLoadHandler = (0, _debounce2.default)(lazyLoadHandler, typeof this.props.debounce === 'number' ? this.props.debounce : 300);
	          delayType = 'debounce';
	        } else if (this.props.throttle !== undefined) {
	          finalLazyLoadHandler = (0, _throttle2.default)(lazyLoadHandler, typeof this.props.throttle === 'number' ? this.props.throttle : 300);
	          delayType = 'throttle';
	        } else {
	          finalLazyLoadHandler = lazyLoadHandler;
	        }
	      }
	
	      if (this.props.overflow) {
	        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
	        if (parent && typeof parent.getAttribute === 'function') {
	          var listenerCount = 1 + +parent.getAttribute(LISTEN_FLAG);
	          if (listenerCount === 1) {
	            parent.addEventListener('scroll', finalLazyLoadHandler, passiveEvent);
	          }
	          parent.setAttribute(LISTEN_FLAG, listenerCount);
	        }
	      } else if (listeners.length === 0 || needResetFinalLazyLoadHandler) {
	        var _props = this.props,
	            scroll = _props.scroll,
	            resize = _props.resize;
	
	
	        if (scroll) {
	          (0, _event.on)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
	        }
	
	        if (resize) {
	          (0, _event.on)(window, 'resize', finalLazyLoadHandler, passiveEvent);
	        }
	      }
	
	      listeners.push(this);
	      checkVisible(this);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      return this.visible;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.overflow) {
	        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
	        if (parent && typeof parent.getAttribute === 'function') {
	          var listenerCount = +parent.getAttribute(LISTEN_FLAG) - 1;
	          if (listenerCount === 0) {
	            parent.removeEventListener('scroll', finalLazyLoadHandler, passiveEvent);
	            parent.removeAttribute(LISTEN_FLAG);
	          } else {
	            parent.setAttribute(LISTEN_FLAG, listenerCount);
	          }
	        }
	      }
	
	      var index = listeners.indexOf(this);
	      if (index !== -1) {
	        listeners.splice(index, 1);
	      }
	
	      if (listeners.length === 0) {
	        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
	        (0, _event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.visible ? this.props.children : this.props.placeholder ? this.props.placeholder : _react2.default.createElement('div', { style: { height: this.props.height }, className: 'lazyload-placeholder' });
	    }
	  }]);
	
	  return LazyLoad;
	}(_react.Component);
	
	LazyLoad.propTypes = {
	  once: _propTypes2.default.bool,
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  offset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)]),
	  overflow: _propTypes2.default.bool,
	  resize: _propTypes2.default.bool,
	  scroll: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  throttle: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
	  debounce: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
	  placeholder: _propTypes2.default.node,
	  unmountIfInvisible: _propTypes2.default.bool
	};
	
	LazyLoad.defaultProps = {
	  once: false,
	  offset: 0,
	  overflow: false,
	  resize: false,
	  scroll: true,
	  unmountIfInvisible: false
	};
	
	var lazyload = exports.lazyload = _decorator2.default;
	exports.default = LazyLoad;
	exports.forceCheck = lazyLoadHandler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(77)))

/***/ }),

/***/ 278:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = debounce;
	function debounce(func, wait, immediate) {
	  var timeout = void 0;
	  var args = void 0;
	  var context = void 0;
	  var timestamp = void 0;
	  var result = void 0;
	
	  var later = function later() {
	    var last = +new Date() - timestamp;
	
	    if (last < wait && last >= 0) {
	      timeout = setTimeout(later, wait - last);
	    } else {
	      timeout = null;
	      if (!immediate) {
	        result = func.apply(context, args);
	        if (!timeout) {
	          context = null;
	          args = null;
	        }
	      }
	    }
	  };
	
	  return function debounced() {
	    context = this;
	    args = arguments;
	    timestamp = +new Date();
	
	    var callNow = immediate && !timeout;
	    if (!timeout) {
	      timeout = setTimeout(later, wait);
	    }
	
	    if (callNow) {
	      result = func.apply(context, args);
	      context = null;
	      args = null;
	    }
	
	    return result;
	  };
	}

/***/ }),

/***/ 279:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.on = on;
	exports.off = off;
	function on(el, eventName, callback, opts) {
	  opts = opts || false;
	  if (el.addEventListener) {
	    el.addEventListener(eventName, callback, opts);
	  } else if (el.attachEvent) {
	    el.attachEvent("on" + eventName, function (e) {
	      callback.call(el, e || window.event);
	    });
	  }
	}
	
	function off(el, eventName, callback, opts) {
	  opts = opts || false;
	  if (el.removeEventListener) {
	    el.removeEventListener(eventName, callback, opts);
	  } else if (el.detachEvent) {
	    el.detachEvent("on" + eventName, callback);
	  }
	}

/***/ }),

/***/ 280:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	/**
	 * @fileOverview Find scroll parent
	 */
	
	exports.default = function (node) {
	  if (!node) {
	    return document.documentElement;
	  }
	
	  var excludeStaticParent = node.style.position === 'absolute';
	  var overflowRegex = /(scroll|auto)/;
	  var parent = node;
	
	  while (parent) {
	    if (!parent.parentNode) {
	      return node.ownerDocument || document.documentElement;
	    }
	
	    var style = window.getComputedStyle(parent);
	    var position = style.position;
	    var overflow = style.overflow;
	    var overflowX = style['overflow-x'];
	    var overflowY = style['overflow-y'];
	
	    if (position === 'static' && excludeStaticParent) {
	      parent = parent.parentNode;
	      continue;
	    }
	
	    if (overflowRegex.test(overflow) && overflowRegex.test(overflowX) && overflowRegex.test(overflowY)) {
	      return parent;
	    }
	
	    parent = parent.parentNode;
	  }
	
	  return node.ownerDocument || node.documentElement || document.documentElement;
	};

/***/ }),

/***/ 281:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = throttle;
	/*eslint-disable */
	function throttle(fn, threshhold, scope) {
	  threshhold || (threshhold = 250);
	  var last, deferTimer;
	  return function () {
	    var context = scope || this;
	
	    var now = +new Date(),
	        args = arguments;
	    if (last && now < last + threshhold) {
	      // hold on to it
	      clearTimeout(deferTimer);
	      deferTimer = setTimeout(function () {
	        last = now;
	        fn.apply(context, args);
	      }, threshhold);
	    } else {
	      last = now;
	      fn.apply(context, args);
	    }
	  };
	}

/***/ }),

/***/ 874:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(282);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(170);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(284);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(272);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(273);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(283);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	var Motion = (function (_React$Component) {
	  _inherits(Motion, _React$Component);
	
	  _createClass(Motion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
	      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      onRest: _propTypes2['default'].func
	    },
	    enumerable: true
	  }]);
	
	  function Motion(props) {
	    var _this = this;
	
	    _classCallCheck(this, Motion);
	
	    _React$Component.call(this, props);
	    this.wasAnimating = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyle = null;
	
	    this.clearUnreadPropStyle = function (destStyle) {
	      var dirty = false;
	      var _state = _this.state;
	      var currentStyle = _state.currentStyle;
	      var currentVelocity = _state.currentVelocity;
	      var lastIdealStyle = _state.lastIdealStyle;
	      var lastIdealVelocity = _state.lastIdealVelocity;
	
	      for (var key in destStyle) {
	        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	          continue;
	        }
	
	        var styleValue = destStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            currentStyle = _extends({}, currentStyle);
	            currentVelocity = _extends({}, currentVelocity);
	            lastIdealStyle = _extends({}, lastIdealStyle);
	            lastIdealVelocity = _extends({}, lastIdealVelocity);
	          }
	
	          currentStyle[key] = styleValue;
	          currentVelocity[key] = 0;
	          lastIdealStyle[key] = styleValue;
	          lastIdealVelocity[key] = 0;
	        }
	      }
	
	      if (dirty) {
	        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
	      }
	    };
	
	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // check if we need to animate in the first place
	        var propsStyle = _this.props.style;
	        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
	          if (_this.wasAnimating && _this.props.onRest) {
	            _this.props.onRest();
	          }
	
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.wasAnimating = false;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        _this.wasAnimating = true;
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};
	
	        for (var key in propsStyle) {
	          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
	            continue;
	          }
	
	          var styleValue = propsStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
	            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
	            for (var i = 0; i < framesToCatchUp; i++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }
	
	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];
	
	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyle: newCurrentStyle,
	          currentVelocity: newCurrentVelocity,
	          lastIdealStyle: newLastIdealStyle,
	          lastIdealVelocity: newLastIdealVelocity
	        });
	
	        _this.unreadPropStyle = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  Motion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyle = _props.defaultStyle;
	    var style = _props.style;
	
	    var currentStyle = defaultStyle || _stripStyle2['default'](style);
	    var currentVelocity = _mapToZero2['default'](currentStyle);
	    return {
	      currentStyle: currentStyle,
	      currentVelocity: currentVelocity,
	      lastIdealStyle: currentStyle,
	      lastIdealVelocity: currentVelocity
	    };
	  };
	
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	
	  Motion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyle != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyle);
	    }
	
	    this.unreadPropStyle = props.style;
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  Motion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyle);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return Motion;
	})(_react2['default'].Component);
	
	exports['default'] = Motion;
	module.exports = exports['default'];
	
	// after checking for unreadPropStyle != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config)

/***/ }),

/***/ 875:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(282);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(170);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(284);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(272);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(273);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(283);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
	  for (var i = 0; i < currentStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	var StaggeredMotion = (function (_React$Component) {
	  _inherits(StaggeredMotion, _React$Component);
	
	  _createClass(StaggeredMotion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
	      styles: _propTypes2['default'].func.isRequired,
	      children: _propTypes2['default'].func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function StaggeredMotion(props) {
	    var _this = this;
	
	    _classCallCheck(this, StaggeredMotion);
	
	    _React$Component.call(this, props);
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;
	
	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _state = _this.state;
	      var currentStyles = _state.currentStyles;
	      var currentVelocities = _state.currentVelocities;
	      var lastIdealStyles = _state.lastIdealStyles;
	      var lastIdealVelocities = _state.lastIdealVelocities;
	
	      var someDirty = false;
	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i];
	        var dirty = false;
	
	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }
	
	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              someDirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	          }
	        }
	      }
	
	      if (someDirty) {
	        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
	      }
	    };
	
	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        var destStyles = _this.props.styles(_this.state.lastIdealStyles);
	
	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var newLastIdealStyles = [];
	        var newLastIdealVelocities = [];
	        var newCurrentStyles = [];
	        var newCurrentVelocities = [];
	
	        for (var i = 0; i < destStyles.length; i++) {
	          var destStyle = destStyles[i];
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};
	
	          for (var key in destStyle) {
	            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	              continue;
	            }
	
	            var styleValue = destStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
	              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }
	
	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];
	
	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }
	
	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities
	        });
	
	        _this.unreadPropStyles = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  StaggeredMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	
	    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
	    var currentVelocities = currentStyles.map(function (currentStyle) {
	      return _mapToZero2['default'](currentStyle);
	    });
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: currentStyles,
	      lastIdealVelocities: currentVelocities
	    };
	  };
	
	  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  StaggeredMotion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return StaggeredMotion;
	})(_react2['default'].Component);
	
	exports['default'] = StaggeredMotion;
	module.exports = exports['default'];
	
	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400
	
	// after checking for unreadPropStyles != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config)

/***/ }),

/***/ 876:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(282);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(170);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(284);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _mergeDiff = __webpack_require__(877);
	
	var _mergeDiff2 = _interopRequireDefault(_mergeDiff);
	
	var _performanceNow = __webpack_require__(272);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(273);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(283);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	// the children function & (potential) styles function asks as param an
	// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
	// {key: string, data?: any, style: PlainStyle}. However, the way we keep
	// internal states doesn't contain such a data structure (check the state and
	// TransitionMotionState). So when children function and others ask for such
	// data we need to generate them on the fly by combining mergedPropsStyles and
	// currentStyles/lastIdealStyles
	function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
	  // Copy the value to a `const` so that Flow understands that the const won't
	  // change and will be non-nullable in the callback below.
	  var cUnreadPropStyles = unreadPropStyles;
	  if (cUnreadPropStyles == null) {
	    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	      return {
	        key: mergedPropsStyle.key,
	        data: mergedPropsStyle.data,
	        style: plainStyles[i]
	      };
	    });
	  }
	  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	    for (var j = 0; j < cUnreadPropStyles.length; j++) {
	      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
	        return {
	          key: cUnreadPropStyles[j].key,
	          data: cUnreadPropStyles[j].data,
	          style: plainStyles[i]
	        };
	      }
	    }
	    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
	  });
	}
	
	function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
	  if (mergedPropsStyles.length !== destStyles.length) {
	    return false;
	  }
	
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (mergedPropsStyles[i].key !== destStyles[i].key) {
	      return false;
	    }
	  }
	
	  // we have the invariant that mergedPropsStyles and
	  // currentStyles/currentVelocities/last* are synced in terms of cells, see
	  // mergeAndSync comment for more info
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	// core key merging logic
	
	// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
	// c}, previous current (interpolating) style is {a, b}
	// **invariant**: current[i] corresponds to merged[i] in terms of key
	
	// steps:
	// turn merged style into {a?, b, c}
	//    add c, value of c is destStyles.c
	//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
	// turn current (interpolating) style from {a, b} into {a?, b, c}
	//    maybe remove a
	//    certainly add c, value of c is willEnter(c)
	// loop over merged and construct new current
	// dest doesn't change, that's owner's
	function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
	  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
	    var leavingStyle = willLeave(oldMergedPropsStyle);
	    if (leavingStyle == null) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
	  });
	
	  var newCurrentStyles = [];
	  var newCurrentVelocities = [];
	  var newLastIdealStyles = [];
	  var newLastIdealVelocities = [];
	  for (var i = 0; i < newMergedPropsStyles.length; i++) {
	    var newMergedPropsStyleCell = newMergedPropsStyles[i];
	    var foundOldIndex = null;
	    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
	      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
	        foundOldIndex = j;
	        break;
	      }
	    }
	    // TODO: key search code
	    if (foundOldIndex == null) {
	      var plainStyle = willEnter(newMergedPropsStyleCell);
	      newCurrentStyles[i] = plainStyle;
	      newLastIdealStyles[i] = plainStyle;
	
	      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
	      newCurrentVelocities[i] = velocity;
	      newLastIdealVelocities[i] = velocity;
	    } else {
	      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
	      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
	      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
	      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
	    }
	  }
	
	  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
	}
	
	var TransitionMotion = (function (_React$Component) {
	  _inherits(TransitionMotion, _React$Component);
	
	  _createClass(TransitionMotion, null, [{
	    key: 'propTypes',
	    value: {
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
	      })),
	      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
	      }))]).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      willEnter: _propTypes2['default'].func,
	      willLeave: _propTypes2['default'].func,
	      didLeave: _propTypes2['default'].func
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      willEnter: function willEnter(styleThatEntered) {
	        return _stripStyle2['default'](styleThatEntered.style);
	      },
	      // recall: returning null makes the current unmounting TransitionStyle
	      // disappear immediately
	      willLeave: function willLeave() {
	        return null;
	      },
	      didLeave: function didLeave() {}
	    },
	    enumerable: true
	  }]);
	
	  function TransitionMotion(props) {
	    var _this = this;
	
	    _classCallCheck(this, TransitionMotion);
	
	    _React$Component.call(this, props);
	    this.unmounting = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;
	
	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	      var mergedPropsStyles = _mergeAndSync[0];
	      var currentStyles = _mergeAndSync[1];
	      var currentVelocities = _mergeAndSync[2];
	      var lastIdealStyles = _mergeAndSync[3];
	      var lastIdealVelocities = _mergeAndSync[4];
	
	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i].style;
	        var dirty = false;
	
	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }
	
	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	              mergedPropsStyles[i] = {
	                key: mergedPropsStyles[i].key,
	                data: mergedPropsStyles[i].data,
	                style: _extends({}, mergedPropsStyles[i].style)
	              };
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	            mergedPropsStyles[i].style[key] = styleValue;
	          }
	        }
	      }
	
	      // unlike the other 2 components, we can't detect staleness and optionally
	      // opt out of setState here. each style object's data might contain new
	      // stuff we're not/cannot compare
	      _this.setState({
	        currentStyles: currentStyles,
	        currentVelocities: currentVelocities,
	        mergedPropsStyles: mergedPropsStyles,
	        lastIdealStyles: lastIdealStyles,
	        lastIdealVelocities: lastIdealVelocities
	      });
	    };
	
	    this.startAnimationIfNecessary = function () {
	      if (_this.unmounting) {
	        return;
	      }
	
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // https://github.com/chenglou/react-motion/pull/420
	        // > if execution passes the conditional if (this.unmounting), then
	        // executes async defaultRaf and after that component unmounts and after
	        // that the callback of defaultRaf is called, then setState will be called
	        // on unmounted component.
	        if (_this.unmounting) {
	          return;
	        }
	
	        var propStyles = _this.props.styles;
	        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;
	
	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	        var newMergedPropsStyles = _mergeAndSync2[0];
	        var newCurrentStyles = _mergeAndSync2[1];
	        var newCurrentVelocities = _mergeAndSync2[2];
	        var newLastIdealStyles = _mergeAndSync2[3];
	        var newLastIdealVelocities = _mergeAndSync2[4];
	
	        for (var i = 0; i < newMergedPropsStyles.length; i++) {
	          var newMergedPropsStyle = newMergedPropsStyles[i].style;
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};
	
	          for (var key in newMergedPropsStyle) {
	            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
	              continue;
	            }
	
	            var styleValue = newMergedPropsStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = newLastIdealStyles[i][key];
	              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }
	
	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];
	
	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }
	
	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities,
	          mergedPropsStyles: newMergedPropsStyles
	        });
	
	        _this.unreadPropStyles = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  TransitionMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	    var willEnter = _props.willEnter;
	    var willLeave = _props.willLeave;
	    var didLeave = _props.didLeave;
	
	    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;
	
	    // this is special. for the first time around, we don't have a comparison
	    // between last (no last) and current merged props. we'll compute last so:
	    // say default is {a, b} and styles (dest style) is {b, c}, we'll
	    // fabricate last as {a, b}
	    var oldMergedPropsStyles = undefined;
	    if (defaultStyles == null) {
	      oldMergedPropsStyles = destStyles;
	    } else {
	      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
	        // TODO: key search code
	        for (var i = 0; i < destStyles.length; i++) {
	          if (destStyles[i].key === defaultStyleCell.key) {
	            return destStyles[i];
	          }
	        }
	        return defaultStyleCell;
	      });
	    }
	    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    });
	    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    });
	
	    var _mergeAndSync3 = mergeAndSync(
	    // Because this is an old-style createReactClass component, Flow doesn't
	    // understand that the willEnter and willLeave props have default values
	    // and will always be present.
	    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
	    oldCurrentVelocities);
	
	    var mergedPropsStyles = _mergeAndSync3[0];
	    var currentStyles = _mergeAndSync3[1];
	    var currentVelocities = _mergeAndSync3[2];
	    var lastIdealStyles = _mergeAndSync3[3];
	    var lastIdealVelocities = _mergeAndSync3[4];
	    // oldLastIdealVelocities really
	
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities,
	      mergedPropsStyles: mergedPropsStyles
	    };
	  };
	
	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	
	  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    var styles = props.styles;
	    if (typeof styles === 'function') {
	      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
	    } else {
	      this.unreadPropStyles = styles;
	    }
	
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounting = true;
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  TransitionMotion.prototype.render = function render() {
	    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
	    var renderedChildren = this.props.children(hydratedStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return TransitionMotion;
	})(_react2['default'].Component);
	
	exports['default'] = TransitionMotion;
	module.exports = exports['default'];
	
	// list of styles, each containing interpolating values. Part of what's passed
	// to children function. Notice that this is
	// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
	// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
	// contains the key & data info (so that we only have a single source of truth
	// for these, and to save space). Check the comment for `rehydrateStyles` to
	// see how we regenerate the entirety of what's passed to children function
	
	// the array that keeps track of currently rendered stuff! Including stuff
	// that you've unmounted but that's still animating. This is where it lives
	
	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400

/***/ }),

/***/ 282:
/***/ (function(module, exports) {

	
	
	// currently used to initiate the velocity style object to 0
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mapToZero;
	
	function mapToZero(obj) {
	  var ret = {};
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      ret[key] = 0;
	    }
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 877:
/***/ (function(module, exports) {

	
	
	// core keys merging algorithm. If previous render's keys are [a, b], and the
	// next render's [c, b, d], what's the final merged keys and ordering?
	
	// - c and a must both be before b
	// - b before d
	// - ordering between a and c ambiguous
	
	// this reduces to merging two partially ordered lists (e.g. lists where not
	// every item has a definite ordering, like comparing a and c above). For the
	// ambiguous ordering we deterministically choose to place the next render's
	// item after the previous'; so c after a
	
	// this is called a topological sorting. Except the existing algorithms don't
	// work well with js bc of the amount of allocation, and isn't optimized for our
	// current use-case bc the runtime is linear in terms of edges (see wiki for
	// meaning), which is huge when two lists have many common elements
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mergeDiff;
	
	function mergeDiff(prev, next, onRemove) {
	  // bookkeeping for easier access of a key's index below. This is 2 allocations +
	  // potentially triggering chrome hash map mode for objs (so it might be faster
	
	  var prevKeyIndex = {};
	  for (var i = 0; i < prev.length; i++) {
	    prevKeyIndex[prev[i].key] = i;
	  }
	  var nextKeyIndex = {};
	  for (var i = 0; i < next.length; i++) {
	    nextKeyIndex[next[i].key] = i;
	  }
	
	  // first, an overly elaborate way of merging prev and next, eliminating
	  // duplicates (in terms of keys). If there's dupe, keep the item in next).
	  // This way of writing it saves allocations
	  var ret = [];
	  for (var i = 0; i < next.length; i++) {
	    ret[i] = next[i];
	  }
	  for (var i = 0; i < prev.length; i++) {
	    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
	      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
	      // merge in keys that the user desires to kill
	      var fill = onRemove(i, prev[i]);
	      if (fill != null) {
	        ret.push(fill);
	      }
	    }
	  }
	
	  // now all the items all present. Core sorting logic to have the right order
	  return ret.sort(function (a, b) {
	    var nextOrderA = nextKeyIndex[a.key];
	    var nextOrderB = nextKeyIndex[b.key];
	    var prevOrderA = prevKeyIndex[a.key];
	    var prevOrderB = prevKeyIndex[b.key];
	
	    if (nextOrderA != null && nextOrderB != null) {
	      // both keys in next
	      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
	    } else if (prevOrderA != null && prevOrderB != null) {
	      // both keys in prev
	      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
	    } else if (nextOrderA != null) {
	      // key a in next, key b in prev
	
	      // how to determine the order between a and b? We find a "pivot" (term
	      // abuse), a key present in both prev and next, that is sandwiched between
	      // a and b. In the context of our above example, if we're comparing a and
	      // d, b's (the only) pivot
	      for (var i = 0; i < next.length; i++) {
	        var pivot = next[i].key;
	        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	          continue;
	        }
	
	        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
	          return -1;
	        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
	          return 1;
	        }
	      }
	      // pluggable. default to: next bigger than prev
	      return 1;
	    }
	    // prevOrderA, nextOrderB
	    for (var i = 0; i < next.length; i++) {
	      var pivot = next[i].key;
	      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	        continue;
	      }
	      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
	        return 1;
	      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
	        return -1;
	      }
	    }
	    // pluggable. default to: next bigger than prev
	    return -1;
	  });
	}
	
	module.exports = exports['default'];
	// to loop through and find a key's index each time), but I no longer care

/***/ }),

/***/ 411:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = {
	  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
	  gentle: { stiffness: 120, damping: 14 },
	  wobbly: { stiffness: 180, damping: 12 },
	  stiff: { stiffness: 210, damping: 20 }
	};
	module.exports = exports["default"];

/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	var _Motion = __webpack_require__(874);
	
	exports.Motion = _interopRequire(_Motion);
	
	var _StaggeredMotion = __webpack_require__(875);
	
	exports.StaggeredMotion = _interopRequire(_StaggeredMotion);
	
	var _TransitionMotion = __webpack_require__(876);
	
	exports.TransitionMotion = _interopRequire(_TransitionMotion);
	
	var _spring = __webpack_require__(879);
	
	exports.spring = _interopRequire(_spring);
	
	var _presets = __webpack_require__(411);
	
	exports.presets = _interopRequire(_presets);
	
	var _stripStyle = __webpack_require__(170);
	
	exports.stripStyle = _interopRequire(_stripStyle);
	
	// deprecated, dummy warning function
	
	var _reorderKeys = __webpack_require__(878);
	
	exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ }),

/***/ 878:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = reorderKeys;
	
	var hasWarned = false;
	
	function reorderKeys() {
	  if (false) {
	    if (!hasWarned) {
	      hasWarned = true;
	      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 283:
/***/ (function(module, exports) {

	
	
	// usage assumption: currentStyle values have already been rendered but it says
	// nothing of whether currentStyle is stale (see unreadPropStyle)
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shouldStopAnimation;
	
	function shouldStopAnimation(currentStyle, style, currentVelocity) {
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	
	    if (currentVelocity[key] !== 0) {
	      return false;
	    }
	
	    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
	    // stepper will have already taken care of rounding precision errors, so
	    // won't have such thing as 0.9999 !=== 1
	    if (currentStyle[key] !== styleValue) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 879:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = spring;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _presets = __webpack_require__(411);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var defaultConfig = _extends({}, _presets2['default'].noWobble, {
	  precision: 0.01
	});
	
	function spring(val, config) {
	  return _extends({}, defaultConfig, config, { val: val });
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 284:
/***/ (function(module, exports) {

	
	
	// stepper is used a lot. Saves allocation to return the same array wrapper.
	// This is fine and danger-free against mutations because the callsite
	// immediately destructures it and gets the numbers inside without passing the
	"use strict";
	
	exports.__esModule = true;
	exports["default"] = stepper;
	
	var reusedTuple = [0, 0];
	
	function stepper(secondPerFrame, x, v, destX, k, b, precision) {
	  // Spring stiffness, in kg / s^2
	
	  // for animations, destX is really spring length (spring at rest). initial
	  // position is considered as the stretched/compressed position of a spring
	  var Fspring = -k * (x - destX);
	
	  // Damping, in kg / s
	  var Fdamper = -b * v;
	
	  // usually we put mass here, but for animation purposes, specifying mass is a
	  // bit redundant. you could simply adjust k and b accordingly
	  // let a = (Fspring + Fdamper) / mass;
	  var a = Fspring + Fdamper;
	
	  var newV = v + a * secondPerFrame;
	  var newX = x + newV * secondPerFrame;
	
	  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
	    reusedTuple[0] = destX;
	    reusedTuple[1] = 0;
	    return reusedTuple;
	  }
	
	  reusedTuple[0] = newX;
	  reusedTuple[1] = newV;
	  return reusedTuple;
	}
	
	module.exports = exports["default"];
	// array reference around.

/***/ }),

/***/ 170:
/***/ (function(module, exports) {

	
	// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
	// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}
	
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = stripStyle;
	
	function stripStyle(style) {
	  var ret = {};
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(99);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _addClass = __webpack_require__(369);
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _removeClass = __webpack_require__(370);
	
	var _removeClass2 = _interopRequireDefault(_removeClass);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Transition = __webpack_require__(137);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _PropTypes = __webpack_require__(138);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var addClass = function addClass(node, classes) {
	  return classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass2.default)(node, c);
	  });
	};
	var removeClass = function removeClass(node, classes) {
	  return classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass2.default)(node, c);
	  });
	};
	
	var propTypes = _extends({}, _Transition2.default.propTypes, {
	
	  /**
	   * The animation classNames applied to the component as it enters or exits.
	   * A single name can be provided and it will be suffixed for each stage: e.g.
	   *
	   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
	   * `fade-exit`, `fade-exit-active`, `fade-appear`, and `fade-appear-active`.
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   * }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** from the DOM node.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * @type Function(node: HtmlElement
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** from the DOM node.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: PropTypes.func
	});
	
	/**
	 * A `Transition` component using CSS transitions and animations.
	 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` stages of the transition. The first class is applied and then a
	 * second "active" class in order to activate the css animation.
	 *
	 * When the `in` prop is toggled to `true` the Component will get
	 * the `example-enter` CSS class and the `example-enter-active` CSS class
	 * added in the next tick. This is a convention based on the `classNames` prop.
	 *
	 * ```js
	 * import CSSTransition from 'react-transition-group/CSSTransition';
	 *
	 * const Fade = ({ children, ...props }) => (
	 *  <CSSTransition
	 *    {...props}
	 *    timeout={500}
	 *    classNames="fade"
	 *  >
	 *   {children}
	 *  </CSSTransition>
	 * );
	 *
	 * class FadeInAndOut extends React.Component {
	 *   constructor(...args) {
	 *     super(...args);
	 *     this.state= { show: false }
	 *
	 *     setInterval(() => {
	 *       this.setState({ show: !this.state.show })
	 *     }, 5000)
	 *   }
	 *   render() {
	 *     return (
	 *       <Fade in={this.state.show}>
	 *         <div>Hello world</div>
	 *       </Fade>
	 *     )
	 *   }
	 * }
	 * ```
	 *
	 * And the coorresponding CSS for the `<Fade>` component:
	 *
	 * ```css
	 * .fade-enter {
	 *   opacity: 0.01;
	 * }
	 *
	 * .fade-enter.fade-enter-active {
	 *   opacity: 1;
	 *   transition: opacity 500ms ease-in;
	 * }
	 *
	 * .fade-exit {
	 *   opacity: 1;
	 * }
	 *
	 * .fade-exit.fade-exit-active {
	 *   opacity: 0.01;
	 *   transition: opacity 300ms ease-in;
	 * }
	 * ```
	 */
	
	var CSSTransition = function (_React$Component) {
	  _inherits(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransition);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onEnter = function (node, appearing) {
	      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          className = _this$getClassNames.className;
	
	      _this.removeClasses(node, 'exit');
	      addClass(node, className);
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node);
	      }
	    }, _this.onEntering = function (node, appearing) {
	      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          activeClassName = _this$getClassNames2.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node);
	      }
	    }, _this.onEntered = function (node, appearing) {
	      _this.removeClasses(node, appearing ? 'appear' : 'enter');
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(node);
	      }
	    }, _this.onExit = function (node) {
	      var _this$getClassNames3 = _this.getClassNames('exit'),
	          className = _this$getClassNames3.className;
	
	      _this.removeClasses(node, 'appear');
	      _this.removeClasses(node, 'enter');
	      addClass(node, className);
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    }, _this.onExiting = function (node) {
	      var _this$getClassNames4 = _this.getClassNames('exit'),
	          activeClassName = _this$getClassNames4.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(node);
	      }
	    }, _this.onExited = function (node) {
	      _this.removeClasses(node, 'exit');
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    }, _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	
	
	      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;
	
	      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';
	
	      return { className: className, activeClassName: activeClassName };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CSSTransition.prototype.removeClasses = function removeClasses(node, type) {
	    var _getClassNames = this.getClassNames(type),
	        className = _getClassNames.className,
	        activeClassName = _getClassNames.activeClassName;
	
	    className && removeClass(node, className);
	    activeClassName && removeClass(node, activeClassName);
	  };
	
	  CSSTransition.prototype.reflowAndAddClass = function reflowAndAddClass(node, className) {
	    // This is for to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	    /* eslint-disable no-unused-expressions */
	    node.scrollTop;
	    /* eslint-enable no-unused-expressions */
	    addClass(node, className);
	  };
	
	  CSSTransition.prototype.render = function render() {
	    var props = _extends({}, this.props);
	
	    delete props.classNames;
	
	    return _react2.default.createElement(_Transition2.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react2.default.Component);
	
	CSSTransition.propTypes =  false ? propTypes : {};
	
	exports.default = CSSTransition;
	module.exports = exports['default'];

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
	
	var _propTypes = __webpack_require__(99);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(25);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _PropTypes = __webpack_require__(138);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
	var EXITED = exports.EXITED = 'exited';
	var ENTERING = exports.ENTERING = 'entering';
	var ENTERED = exports.ENTERED = 'entered';
	var EXITING = exports.EXITING = 'exiting';
	
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the components.
	 * It's up to you to give meaning and effect to those states. For example we can
	 * add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import Transition from 'react-transition-group/Transition';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {(state) => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm A fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
	 * What it does do is track transition states over time so you can update the
	 * component (such as by adding styles or classes) when it changes states.
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `ENTERING`
	 *  - `ENTERED`
	 *  - `EXITING`
	 *  - `EXITED`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component begins the
	 * "Enter" stage. During this stage, the component will shift from its current transition state,
	 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
	 * it's complete. Let's take the following example:
	 *
	 * ```jsx
	 * state= { in: false };
	 *
	 * toggleEnterState = () => {
	 *   this.setState({ in: true });
	 * }
	 *
	 * render() {
	 *   return (
	 *     <div>
	 *       <Transition in={this.state.in} timeout={500} />
	 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state and
	 * stay there for 500ms (the value of `timeout`) when finally switches to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
	 */
	
	var Transition = function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props, context) {
	    _classCallCheck(this, Transition);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    var parentGroup = context.transitionGroup;
	    // In the context of a TransitionGroup all enters are really appears
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	
	    var initialStatus = void 0;
	    _this.nextStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.nextStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = { status: initialStatus };
	
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  Transition.prototype.getChildContext = function getChildContext() {
	    return { transitionGroup: null }; // allows for nested Transitions
	  };
	
	  Transition.prototype.componentDidMount = function componentDidMount() {
	    this.updateStatus(true);
	  };
	
	  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _ref = this.pendingState || this.state,
	        status = _ref.status;
	
	    if (nextProps.in) {
	      if (status === UNMOUNTED) {
	        this.setState({ status: EXITED });
	      }
	      if (status !== ENTERING && status !== ENTERED) {
	        this.nextStatus = ENTERING;
	      }
	    } else {
	      if (status === ENTERING || status === ENTERED) {
	        this.nextStatus = EXITING;
	      }
	    }
	  };
	
	  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.updateStatus();
	  };
	
	  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  Transition.prototype.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	
	    var exit = void 0,
	        enter = void 0,
	        appear = void 0;
	
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter;
	      appear = timeout.appear;
	    }
	    return { exit: exit, enter: enter, appear: appear };
	  };
	
	  Transition.prototype.updateStatus = function updateStatus() {
	    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var nextStatus = this.nextStatus;
	
	    if (nextStatus !== null) {
	      this.nextStatus = null;
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	      var node = _reactDom2.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({ status: UNMOUNTED });
	    }
	  };
	
	  Transition.prototype.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	
	    var timeouts = this.getTimeouts();
	
	    // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	    if (!mounting && !enter) {
	      this.safeSetState({ status: ENTERED }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	
	    this.safeSetState({ status: ENTERING }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      // FIXME: appear timeout?
	      _this2.onTransitionEnd(node, timeouts.enter, function () {
	        _this2.safeSetState({ status: ENTERED }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  Transition.prototype.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	
	    var timeouts = this.getTimeouts();
	
	    // no exit animation skip right to EXITED
	    if (!exit) {
	      this.safeSetState({ status: EXITED }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	    this.props.onExit(node);
	
	    this.safeSetState({ status: EXITING }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({ status: EXITED }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
	    var _this4 = this;
	
	    // We need to track pending updates for instances where a cWRP fires quickly
	    // after cDM and before the state flushes, which would double trigger a
	    // transition
	    this.pendingState = nextState;
	
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, function () {
	      _this4.pendingState = null;
	      callback();
	    });
	  };
	
	  Transition.prototype.setNextCallback = function setNextCallback(callback) {
	    var _this5 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this5.nextCallback = null;
	
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	
	    if (node) {
	      if (this.props.addEndListener) {
	        this.props.addEndListener(node, this.nextCallback);
	      }
	      if (timeout != null) {
	        setTimeout(this.nextCallback, timeout);
	      }
	    } else {
	      setTimeout(this.nextCallback, 0);
	    }
	  };
	
	  Transition.prototype.render = function render() {
	    var status = this.state.status;
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _props = this.props,
	        children = _props.children,
	        childProps = _objectWithoutProperties(_props, ['children']);
	    // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react2.default.Children.only(children);
	    return _react2.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react2.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	
	
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element.
	   * This function is called with the current transition status
	   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can used
	   * to apply context specific props to a component.
	   *
	   * ```jsx
	   * <Transition timeout={150}>
	   *   {(status) => (
	   *     <MyComponent className={`fade fade-${status}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEventListener` is provided
	   *
	   * You may specify a single timeout for all transitions like: `timeout={500}`,
	   * or individually like:
	   *
	   * ```jsx
	   * timeout={{
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * @type {number | { enter?: number, exit?: number }}
	   */
	  timeout: function timeout(props) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	    return pt.apply(undefined, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func
	} : {};
	
	// Name the function so it is clearer in the documentation
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	exports.default = Transition;

/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(99);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChildMapping = __webpack_require__(306);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var propTypes = {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   */
	  component: _propTypes2.default.any,
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * A convenience prop that enables or disabled appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes2.default.bool,
	  /**
	   * A convenience prop that enables or disabled enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes2.default.bool,
	  /**
	    * A convenience prop that enables or disabled exit animations
	    * for all children. Note that specifying this will override any defaults set
	    * on individual children Transitions.
	    */
	  exit: _propTypes2.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes2.default.func
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	/**
	 * The `<TransitionGroup>` component manages a set of `<Transition>` components
	 * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
	 * state machine for managing the mounting and unmounting of components over
	 * time.
	 *
	 * Consider the example below using the `Fade` CSS transition from before.
	 * As items are removed or added to the TodoList the `in` prop is toggled
	 * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
	 * component in a `<TransitionGroup>`, not just css.
	 *
	 * ```jsx
	 * import TransitionGroup from 'react-transition-group/TransitionGroup';
	 *
	 * class TodoList extends React.Component {
	 *   constructor(props) {
	 *     super(props)
	 *     this.state = {items: ['hello', 'world', 'click', 'me']}
	 *   }
	 *   handleAdd() {
	 *     const newItems = this.state.items.concat([
	 *       prompt('Enter some text')
	 *     ]);
	 *     this.setState({ items: newItems });
	 *   }
	 *   handleRemove(i) {
	 *     let newItems = this.state.items.slice();
	 *     newItems.splice(i, 1);
	 *     this.setState({items: newItems});
	 *   }
	 *   render() {
	 *     return (
	 *       <div>
	 *         <button onClick={() => this.handleAdd()}>Add Item</button>
	 *         <TransitionGroup>
	 *           {this.state.items.map((item, i) => (
	 *             <FadeTransition key={item}>
	 *               <div>
	 *                 {item}{' '}
	 *                 <button onClick={() => this.handleRemove(i)}>
	 *                   remove
	 *                 </button>
	 *               </div>
	 *             </FadeTransition>
	 *           ))}
	 *         </TransitionGroup>
	 *       </div>
	 *     );
	 *   }
	 * }
	 * ```
	 *
	 * Note that `<TransitionGroup>`  does not define any animation behavior!
	 * Exactly _how_ a list item animates is up to the individual `<Transition>`
	 * components. This means you can mix and match animations across different
	 * list items.
	 */
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    // Initial children should all be entering, dependent on appear
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.handleExited = function (key, node, originalHandler) {
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (key in currentChildMapping) return;
	
	      if (originalHandler) originalHandler(node);
	
	      _this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[key];
	        return { children: children };
	      });
	    };
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children, function (child) {
	        var onExited = function onExited(node) {
	          _this.handleExited(child.key, node, child.props.onExited);
	        };
	
	        return (0, _react.cloneElement)(child, {
	          onExited: onExited,
	          in: true,
	          appear: _this.getProp(child, 'appear'),
	          enter: _this.getProp(child, 'enter'),
	          exit: _this.getProp(child, 'exit')
	        });
	      })
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: { isMounting: !this.appeared }
	    };
	  };
	  // use child config unless explictly set by the Group
	
	
	  TransitionGroup.prototype.getProp = function getProp(child, prop) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props;
	
	    return props[prop] != null ? props[prop] : child.props[prop];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    var prevChildMapping = this.state.children;
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	
	    var children = (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping);
	
	    Object.keys(children).forEach(function (key) {
	      var child = children[key];
	
	      if (!(0, _react.isValidElement)(child)) return;
	
	      var onExited = function onExited(node) {
	        _this2.handleExited(child.key, node, child.props.onExited);
	      };
	
	      var hasPrev = key in prevChildMapping;
	      var hasNext = key in nextChildMapping;
	
	      var prevChild = prevChildMapping[key];
	      var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;
	
	      // item is new (entering)
	      if (hasNext && (!hasPrev || isLeaving)) {
	        // console.log('entering', key)
	        children[key] = (0, _react.cloneElement)(child, {
	          onExited: onExited,
	          in: true,
	          exit: _this2.getProp(child, 'exit', nextProps),
	          enter: _this2.getProp(child, 'enter', nextProps)
	        });
	      }
	      // item is old (exiting)
	      else if (!hasNext && hasPrev && !isLeaving) {
	          // console.log('leaving', key)
	          children[key] = (0, _react.cloneElement)(child, { in: false });
	        }
	        // item hasn't changed transition states
	        // copy over the last transition props;
	        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	            // console.log('unchanged', key)
	            children[key] = (0, _react.cloneElement)(child, {
	              onExited: onExited,
	              in: prevChild.props.in,
	              exit: _this2.getProp(child, 'exit', nextProps),
	              enter: _this2.getProp(child, 'enter', nextProps)
	            });
	          }
	    });
	
	    this.setState({ children: children });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.component,
	        childFactory = _props.childFactory,
	        props = _objectWithoutProperties(_props, ['component', 'childFactory']);
	
	    var children = this.state.children;
	
	
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    return _react2.default.createElement(
	      Component,
	      props,
	      values(children).map(childFactory)
	    );
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.childContextTypes = {
	  transitionGroup: _propTypes2.default.object.isRequired
	};
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _CSSTransition = __webpack_require__(303);
	
	var _CSSTransition2 = _interopRequireDefault(_CSSTransition);
	
	var _TransitionGroup = __webpack_require__(304);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _Transition = __webpack_require__(137);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  Transition: _Transition2.default,
	  TransitionGroup: _TransitionGroup2.default,
	  CSSTransition: _CSSTransition2.default
	};

/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = Object.create(null);
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
	  enter: _propTypes2.default.number,
	  exit: _propTypes2.default.number
	}).isRequired]);
	
	var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  exit: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  exit: _propTypes2.default.string,
	  exitActive: _propTypes2.default.string
	})]);

/***/ }),

/***/ 958:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _animationBus = __webpack_require__(337);
	
	var _animationBus2 = _interopRequireDefault(_animationBus);
	
	var _Pager = __webpack_require__(139);
	
	var _Pager2 = _interopRequireDefault(_Pager);
	
	var _specialAssign = __webpack_require__(307);
	
	var _specialAssign2 = _interopRequireDefault(_specialAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var checkedProps = {
	  tag: _propTypes2.default.string,
	  index: _propTypes2.default.number,
	  animations: _propTypes2.default.array
	};
	
	var AnimatedView = function (_Component) {
	  _inherits(AnimatedView, _Component);
	
	  function AnimatedView() {
	    _classCallCheck(this, AnimatedView);
	
	    return _possibleConstructorReturn(this, (AnimatedView.__proto__ || Object.getPrototypeOf(AnimatedView)).apply(this, arguments));
	  }
	
	  _createClass(AnimatedView, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var animations = this.props.animations;
	
	
	      if (animations.length) {
	        this._animationBus = new _animationBus2.default({
	          animations: animations,
	          origin: function origin(view) {
	            return view.origin;
	          }
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          tag = _props.tag,
	          index = _props.index,
	          restProps = _objectWithoutProperties(_props, ['tag', 'index']);
	
	      var style = _extends({}, restProps.style);
	
	      if (this._animationBus) {
	        var view = this.context.view || this.context.pager.getView(index);
	        if (view) {
	          style = _extends({}, restProps.style, this._animationBus.getStyles(view));
	        }
	      }
	
	      return (0, _react.createElement)(tag, (0, _specialAssign2.default)({ style: style }, this.props, checkedProps));
	    }
	  }]);
	
	  return AnimatedView;
	}(_react.Component);
	
	AnimatedView.contextTypes = {
	  pager: _propTypes2.default.instanceOf(_Pager2.default),
	  view: _propTypes2.default.any
	};
	AnimatedView.propTypes = checkedProps;
	AnimatedView.defaultProps = {
	  tag: 'div',
	  animations: []
	};
	exports.default = AnimatedView;
	module.exports = exports['default'];

/***/ }),

/***/ 959:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(25);
	
	var _reactMotion = __webpack_require__(412);
	
	var _Pager = __webpack_require__(139);
	
	var _Pager2 = _interopRequireDefault(_Pager);
	
	var _Swipe = __webpack_require__(962);
	
	var _Swipe2 = _interopRequireDefault(_Swipe);
	
	var _Keyboard = __webpack_require__(960);
	
	var _Keyboard2 = _interopRequireDefault(_Keyboard);
	
	var _specialAssign = __webpack_require__(307);
	
	var _specialAssign2 = _interopRequireDefault(_specialAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var checkedProps = {
	  tag: _propTypes2.default.any,
	  autoSize: _propTypes2.default.oneOf([true, false, 'width', 'height']),
	  accessibility: _propTypes2.default.bool,
	  springConfig: _propTypes2.default.objectOf(_propTypes2.default.number)
	};
	
	var Frame = function (_Component) {
	  _inherits(Frame, _Component);
	
	  function Frame(props) {
	    _classCallCheck(this, Frame);
	
	    var _this = _possibleConstructorReturn(this, (Frame.__proto__ || Object.getPrototypeOf(Frame)).call(this, props));
	
	    _this._setFrameSize = function () {
	      var frameSize = _this.context.pager.getFrameSize({ fullSize: true });
	
	      if (frameSize.width && frameSize.height) {
	        _this.setState(frameSize, function () {
	          // we need to unset the instant flag now that React Motion has dimensions to animate to
	          if (_this.state.instant) {
	            _this.setState({ instant: false });
	          }
	        });
	      }
	    };
	
	    _this.state = {
	      width: 0,
	      height: 0,
	      instant: true
	    };
	    _this._hydrate = false;
	    return _this;
	  }
	
	  _createClass(Frame, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var pager = this.context.pager;
	      var _props = this.props,
	          autoSize = _props.autoSize,
	          accessibility = _props.accessibility;
	
	
	      pager.setOptions({ autoSize: autoSize, accessibility: accessibility });
	
	      this._swipe = new _Swipe2.default(pager);
	      this._keyboard = new _Keyboard2.default(pager);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var pager = this.context.pager;
	
	
	      pager.addFrame((0, _reactDom.findDOMNode)(this));
	
	      // set frame size initially and then based on certain pager events
	      this._setFrameSize();
	      pager.on('viewChange', this._setFrameSize);
	      pager.on('hydrated', this._setFrameSize);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(_ref) {
	      var autoSize = _ref.autoSize,
	          accessibility = _ref.accessibility;
	
	      // update any options that have changed
	      if (this.props.autoSize !== autoSize || this.props.accessibility !== accessibility) {
	        this.context.pager.setOptions({ autoSize: autoSize, accessibility: accessibility });
	        this._hydrate = true;
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(nextProps) {
	      if (this._hydrate) {
	        this.context.pager.hydrate();
	        this._hydrate = false;
	      }
	    }
	  }, {
	    key: '_getFrameStyle',
	    value: function _getFrameStyle() {
	      var springConfig = this.props.springConfig;
	      var _state = this.state,
	          width = _state.width,
	          height = _state.height,
	          instant = _state.instant;
	
	      return {
	        maxWidth: instant ? width : (0, _reactMotion.spring)(width, springConfig),
	        height: instant ? height : (0, _reactMotion.spring)(height, springConfig)
	      };
	    }
	  }, {
	    key: '_renderFrame',
	    value: function _renderFrame(style) {
	      var pager = this.context.pager;
	      var _props2 = this.props,
	          tag = _props2.tag,
	          accessibility = _props2.accessibility;
	
	      var props = (0, _specialAssign2.default)(_extends({}, this._swipe.getEvents(), this._keyboard.getEvents(), {
	        tabIndex: accessibility ? 0 : null
	      }), this.props, checkedProps);
	
	      return (0, _react.createElement)(tag, _extends({}, props, {
	        style: _extends({}, style, props.style)
	      }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var autoSize = this.props.autoSize;
	      var height = this.state.height;
	
	      var style = {
	        position: 'relative',
	        overflow: 'hidden'
	      };
	
	      if (autoSize) {
	        return _react2.default.createElement(
	          _reactMotion.Motion,
	          { style: this._getFrameStyle() },
	          function (dimensions) {
	            if ((autoSize === true || autoSize === 'width') && dimensions.maxWidth) {
	              style.maxWidth = dimensions.maxWidth;
	            }
	            if ((autoSize === true || autoSize === 'height') && dimensions.height) {
	              style.height = dimensions.height;
	            }
	            return _this2._renderFrame(style);
	          }
	        );
	      } else {
	        return this._renderFrame(style);
	      }
	    }
	  }]);
	
	  return Frame;
	}(_react.Component);
	
	Frame.contextTypes = {
	  pager: _propTypes2.default.instanceOf(_Pager2.default)
	};
	Frame.propTypes = checkedProps;
	Frame.defaultProps = {
	  tag: 'div',
	  autoSize: false,
	  accessibility: true,
	  springConfig: _reactMotion.presets.noWobble
	};
	exports.default = Frame;
	module.exports = exports['default'];

/***/ }),

/***/ 960:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(308);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Keyboard = function () {
	  function Keyboard(pager) {
	    var _this = this;
	
	    _classCallCheck(this, Keyboard);
	
	    this._handleKeyDown = function (e) {
	      // handle respective key controls
	      switch (e.key) {
	        // move to the previous view
	        case 'ArrowUp':
	        case 'ArrowLeft':
	          _this.pager.prev();
	          return;
	
	        // move to the next view
	        case 'ArrowDown':
	        case 'ArrowRight':
	        case ' ':
	          _this.pager.next();
	          return;
	
	        // move to first view
	        case 'Home':
	          _this.pager.setCurrentView({ index: 0 });
	          return;
	
	        // move to last view
	        case 'End':
	          _this.pager.setCurrentView({ index: _this.pager.views.length - 1 });
	          return;
	      }
	
	      // 1 - 9 keys mapped to respective slide number
	      var maxNumKey = (0, _utils.clamp)(_this.pager.views.length, 0, 9);
	
	      for (var i = 1; i <= maxNumKey; i++) {
	        if (+e.key === i) {
	          _this.pager.setCurrentView({ index: i - 1 });
	        }
	      }
	    };
	
	    this.pager = pager;
	  }
	
	  _createClass(Keyboard, [{
	    key: 'getEvents',
	    value: function getEvents() {
	      var keyboardEvents = {};
	
	      if (this.pager.options.accessibility) {
	        keyboardEvents.onKeyDown = this._handleKeyDown;
	      }
	
	      return keyboardEvents;
	    }
	  }]);
	
	  return Keyboard;
	}();
	
	exports.default = Keyboard;
	module.exports = exports['default'];

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _mitt = __webpack_require__(269);
	
	var _mitt2 = _interopRequireDefault(_mitt);
	
	var _tabbable = __webpack_require__(1121);
	
	var _tabbable2 = _interopRequireDefault(_tabbable);
	
	var _animationBus = __webpack_require__(337);
	
	var _animationBus2 = _interopRequireDefault(_animationBus);
	
	var _resizeObserverPolyfill = __webpack_require__(989);
	
	var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);
	
	var _PagerElement3 = __webpack_require__(961);
	
	var _PagerElement4 = _interopRequireDefault(_PagerElement3);
	
	var _utils = __webpack_require__(308);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TRANSFORM = __webpack_require__(722)('transform');
	var isWindowDefined = typeof window !== 'undefined';
	
	var Track = function (_PagerElement) {
	  _inherits(Track, _PagerElement);
	
	  function Track() {
	    _classCallCheck(this, Track);
	
	    return _possibleConstructorReturn(this, (Track.__proto__ || Object.getPrototypeOf(Track)).apply(this, arguments));
	  }
	
	  _createClass(Track, [{
	    key: 'getStyles',
	    value: function getStyles(trackPosition) {
	      var _pager$getPositionVal = this.pager.getPositionValue(trackPosition),
	          x = _pager$getPositionVal.x,
	          y = _pager$getPositionVal.y;
	
	      var trackSize = this.pager.getTrackSize();
	      var style = _defineProperty({}, TRANSFORM, 'translate3d(' + x + 'px, ' + y + 'px, 0)');
	
	      if (trackSize) {
	        var _pager$options = this.pager.options,
	            axis = _pager$options.axis,
	            viewsToShow = _pager$options.viewsToShow;
	
	        var dimension = axis === 'x' ? 'width' : 'height';
	
	        style[dimension] = viewsToShow === 'auto' ? trackSize : this.pager.views.length / viewsToShow * 100 + '%';
	      }
	
	      return style;
	    }
	  }]);
	
	  return Track;
	}(_PagerElement4.default);
	
	var View = function (_PagerElement2) {
	  _inherits(View, _PagerElement2);
	
	  function View(_ref) {
	    var index = _ref.index,
	        restOptions = _objectWithoutProperties(_ref, ['index']);
	
	    _classCallCheck(this, View);
	
	    var _this2 = _possibleConstructorReturn(this, (View.__proto__ || Object.getPrototypeOf(View)).call(this, restOptions));
	
	    _this2.index = index;
	    _this2.inBounds = true;
	    _this2.tabbableChildren = [];
	    _this2.setCurrent(false);
	    _this2.setVisible(false);
	    _this2.setTarget();
	    _this2.setOrigin();
	
	    // TODO: look into getting rid of setTimeout
	    // not sure the reason for needing setTimeout in order to get proper children,
	    // might be due to something in React that we're not doing at the right time
	    setTimeout(function () {
	      _this2.tabbableChildren = (0, _tabbable2.default)(_this2.node);
	      _this2.setTabbableChildren();
	    });
	    return _this2;
	  }
	
	  _createClass(View, [{
	    key: 'setCurrent',
	    value: function setCurrent(isCurrent) {
	      this.isCurrent = isCurrent;
	    }
	  }, {
	    key: 'setVisible',
	    value: function setVisible(isVisible) {
	      this.isVisible = isVisible;
	      this.setTabbableChildren();
	    }
	  }, {
	    key: 'setTabbableChildren',
	    value: function setTabbableChildren() {
	      // only allow tabbing in current slides
	      for (var i = 0; i < this.tabbableChildren.length; i++) {
	        this.tabbableChildren[i].tabIndex = this.isCurrent ? 0 : -1;
	      }
	    }
	  }, {
	    key: 'setTarget',
	    value: function setTarget() {
	      var _pager$options2 = this.pager.options,
	          align = _pager$options2.align,
	          viewsToShow = _pager$options2.viewsToShow;
	
	      var target = this.pager.getStartCoords(this.index);
	
	      if (align) {
	        target += this.pager.getAlignOffset(this);
	      }
	
	      this.target = target;
	    }
	  }, {
	    key: 'setOrigin',
	    value: function setOrigin() {
	      var trackPosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.pager.trackPosition;
	
	      this.origin = this.target - trackPosition;
	    }
	  }, {
	    key: 'getStyles',
	    value: function getStyles() {
	      var _pager$options3 = this.pager.options,
	          axis = _pager$options3.axis,
	          viewsToShow = _pager$options3.viewsToShow,
	          infinite = _pager$options3.infinite;
	
	      var style = {};
	
	      // we need to position views inline when using the x axis
	      if (axis === 'x') {
	        style.display = 'inline-block';
	        style.verticalAlign = 'top';
	      }
	
	      // set width or height on view when viewsToShow is not auto
	      if (viewsToShow !== 'auto') {
	        style[axis === 'x' ? 'width' : 'height'] = 100 / this.pager.views.length + '%';
	      }
	
	      // make sure view stays in frame when using infinite option
	      if (infinite && !this.inBounds) {
	        style.position = 'relative';
	        style[axis === 'y' ? 'top' : 'left'] = this.getPosition();
	      }
	
	      // finally, apply any animations
	      return _extends({}, style, this.pager.animationBus.getStyles(this));
	    }
	  }]);
	
	  return View;
	}(_PagerElement4.default);
	
	var defaultOptions = {
	  viewsToShow: 1,
	  viewsToMove: 1,
	  align: 0,
	  contain: false,
	  axis: 'x',
	  autoSize: false,
	  animations: [],
	  infinite: false,
	  instant: false,
	  swipe: true,
	  swipeThreshold: 0.5,
	  flickTimeout: 300,
	  accessibility: true
	};
	
	var Pager = function () {
	  function Pager() {
	    var _this3 = this;
	
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, Pager);
	
	    this.hydrate = function () {
	      _this3.frame.setSize();
	      _this3.track.setSize();
	      _this3.views.forEach(function (view) {
	        view.setSize();
	        view.setTarget();
	      });
	      _this3.setPositionValue();
	      _this3.setViewStyles();
	      _this3.emit('hydrated');
	    };
	
	    var emitter = (0, _mitt2.default)();
	
	    this.on = emitter.on;
	    this.emit = emitter.emit;
	    this.off = emitter.off;
	
	    this.views = [];
	    this.currentIndex = 0;
	    this.currentView = null;
	    this.currentTween = 0;
	    this.trackPosition = 0;
	    this.isSwiping = false;
	
	    this.options = _extends({}, defaultOptions, options);
	
	    this.animationBus = new _animationBus2.default({
	      animations: this.options.animations,
	      origin: function origin(view) {
	        return view.origin;
	      }
	    });
	
	    if (isWindowDefined) {
	      this.resizeObserver = new _resizeObserverPolyfill2.default(function () {
	        _this3.hydrate();
	      });
	    }
	  }
	
	  _createClass(Pager, [{
	    key: 'setOptions',
	    value: function setOptions(options) {
	      var lastOptions = this.options;
	
	      // spread new options over the old ones
	      this.options = _extends({}, this.options, options);
	
	      // merge animations into animation bus
	      this.animationBus.animations = this.options.animations;
	
	      // fire a viewChange event with the new indicies if viewsToShow has changed
	      if (lastOptions.viewsToShow !== this.options.viewsToShow) {
	        this.emit('viewChange', this.getCurrentIndicies());
	      }
	    }
	  }, {
	    key: 'addFrame',
	    value: function addFrame(node) {
	      this.frame = new _PagerElement4.default({
	        node: node,
	        pager: this
	      });
	    }
	  }, {
	    key: 'addTrack',
	    value: function addTrack(node) {
	      this.track = new Track({
	        node: node,
	        pager: this
	      });
	    }
	  }, {
	    key: 'addView',
	    value: function addView(node) {
	      var index = this.views.length;
	      var view = new View({
	        node: node,
	        index: index,
	        pager: this
	      });
	
	      // add view to collection
	      this.views.push(view);
	
	      // set this as the first view if there isn't one yet
	      if (!this.currentView) {
	        this.setCurrentView({
	          index: index,
	          suppressEvent: true
	        });
	      }
	
	      // listen for width and height changes
	      if (isWindowDefined) {
	        this.resizeObserver.observe(node);
	      }
	
	      // fire an event
	      this.emit('viewAdded');
	
	      return view;
	    }
	  }, {
	    key: 'removeView',
	    value: function removeView(view) {
	      // filter out view
	      this.views = this.views.filter(function (_view) {
	        return view !== _view;
	      });
	
	      // stop observing node
	      if (isWindowDefined) {
	        this.resizeObserver.disconnect(view.node);
	      }
	
	      // fire an event
	      this.emit('viewRemoved');
	    }
	  }, {
	    key: 'prev',
	    value: function prev() {
	      this.setCurrentView({ direction: -1 });
	    }
	  }, {
	    key: 'next',
	    value: function next() {
	      this.setCurrentView({ direction: 1 });
	    }
	  }, {
	    key: 'setCurrentView',
	    value: function setCurrentView(_ref2) {
	      var _ref2$direction = _ref2.direction,
	          direction = _ref2$direction === undefined ? 0 : _ref2$direction,
	          _ref2$index = _ref2.index,
	          index = _ref2$index === undefined ? this.currentIndex : _ref2$index,
	          _ref2$suppressEvent = _ref2.suppressEvent,
	          suppressEvent = _ref2$suppressEvent === undefined ? false : _ref2$suppressEvent;
	      var _options = this.options,
	          viewsToMove = _options.viewsToMove,
	          infinite = _options.infinite;
	
	      var newIndex = index + direction * viewsToMove;
	
	      var previousIndex = this.currentIndex;
	      var currentIndex = infinite ? newIndex : (0, _utils.clamp)(newIndex, 0, this.views.length - 1);
	
	      var previousView = this.getView(previousIndex);
	      var currentView = this.getView(currentIndex);
	
	      // set current index and view
	      this.currentIndex = currentIndex;
	      this.currentView = currentView;
	
	      // swap current view flags
	      previousView.setCurrent(false);
	      currentView.setCurrent(true);
	
	      var rangeStart = currentIndex;
	      var rangeEnd = currentIndex + viewsToMove - 1;
	      var viewRange = (0, _utils.range)(rangeStart, rangeEnd, this.views.length);
	
	      // set flags for which views are currently showing
	      this.views.forEach(function (view, index) {
	        view.setVisible(index === currentIndex);
	      });
	
	      // set the track position to the new view
	      this.setPositionValue();
	
	      if (!suppressEvent) {
	        this.emit('viewChange', this.getCurrentIndicies());
	      }
	    }
	  }, {
	    key: 'setPositionValue',
	    value: function setPositionValue() {
	      var trackPosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.currentView ? this.currentView.target : 0;
	
	      if (!this.isSwiping) {
	        var _options2 = this.options,
	            viewsToShow = _options2.viewsToShow,
	            autoSize = _options2.autoSize,
	            infinite = _options2.infinite,
	            contain = _options2.contain;
	
	        var trackSize = this.getTrackSize();
	
	        if (infinite) {
	          // we offset by a track multiplier so infinite animation can take advantage of
	          // physics by animating to a large value, the final value provided in getTransformValue
	          // will return the proper wrapped value
	          trackPosition -= (Math.floor(this.currentIndex / this.views.length) || 0) * trackSize;
	        }
	
	        if (contain) {
	          var trackEndOffset = viewsToShow === 'auto' && autoSize || viewsToShow <= 1 ? 0 : this.getFrameSize({ autoSize: false });
	          trackPosition = (0, _utils.clamp)(trackPosition, trackEndOffset - trackSize, 0);
	        }
	      }
	
	      this.trackPosition = trackPosition;
	    }
	  }, {
	    key: 'setViewStyles',
	    value: function setViewStyles() {
	      var trackPosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var _options3 = this.options,
	          infinite = _options3.infinite,
	          align = _options3.align;
	
	      var frameSize = this.getFrameSize();
	      var trackSize = this.getTrackSize();
	      var wrappedtrackPosition = (0, _utils.modulo)(trackPosition, -trackSize);
	
	      this.views.reduce(function (lastPosition, view, index) {
	        var viewSize = view.getSize();
	        var nextPosition = lastPosition + viewSize;
	        var position = lastPosition;
	
	        if (nextPosition + viewSize * align < Math.abs(wrappedtrackPosition)) {
	          // shift views around so they are always visible in frame
	          if (infinite) {
	            position += trackSize - lastPosition;
	          }
	          view.inBounds = false;
	        } else {
	          view.inBounds = true;
	        }
	
	        view.setPosition(position);
	        view.setOrigin(trackPosition);
	
	        return nextPosition;
	      }, 0);
	    }
	  }, {
	    key: 'getNumericViewsToShow',
	    value: function getNumericViewsToShow() {
	      return isNaN(this.options.viewsToShow) ? 1 : this.options.viewsToShow;
	    }
	  }, {
	    key: 'getMaxDimensions',
	    value: function getMaxDimensions(indices) {
	      var _this4 = this;
	
	      var axis = this.options.axis;
	
	      var widths = [];
	      var heights = [];
	
	      indices.forEach(function (index) {
	        var view = isNaN(index) ? index : _this4.getView(index);
	        widths.push(view.getSize('width'));
	        heights.push(view.getSize('height'));
	      });
	
	      return {
	        width: axis === 'x' ? (0, _utils.sum)(widths) : (0, _utils.max)(widths),
	        height: axis === 'y' ? (0, _utils.sum)(heights) : (0, _utils.max)(heights)
	      };
	    }
	  }, {
	    key: 'getCurrentIndicies',
	    value: function getCurrentIndicies() {
	      var _options4 = this.options,
	          infinite = _options4.infinite,
	          contain = _options4.contain;
	
	      var currentViews = [];
	      var viewsToShow = isNaN(this.options.viewsToShow) ? 1 : this.options.viewsToShow;
	      var minIndex = this.currentIndex;
	      var maxIndex = this.currentIndex + (viewsToShow - 1);
	
	      if (contain) {
	        // if containing, we need to clamp the start and end indexes so we only return what's in view
	        minIndex = (0, _utils.clamp)(minIndex, 0, this.views.length - viewsToShow);
	        maxIndex = (0, _utils.clamp)(maxIndex, 0, this.views.length - 1);
	        for (var i = minIndex; i <= maxIndex; i++) {
	          currentViews.push(i);
	        }
	      } else {
	        for (var _i = minIndex; _i <= maxIndex; _i++) {
	          currentViews.push(infinite ? (0, _utils.modulo)(_i, this.views.length) : (0, _utils.clamp)(_i, 0, this.views.length - 1));
	        }
	      }
	
	      return currentViews;
	    }
	  }, {
	    key: 'getFrameSize',
	    value: function getFrameSize() {
	      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref3$autoSize = _ref3.autoSize,
	          autoSize = _ref3$autoSize === undefined ? this.options.autoSize : _ref3$autoSize,
	          _ref3$fullSize = _ref3.fullSize,
	          fullSize = _ref3$fullSize === undefined ? false : _ref3$fullSize;
	
	      var dimensions = {
	        width: 0,
	        height: 0
	      };
	
	      if (this.views.length) {
	        if (autoSize) {
	          var currentViews = this.getCurrentIndicies();
	          dimensions = this.getMaxDimensions(currentViews);
	        } else if (this.frame) {
	          dimensions = {
	            width: this.frame.getSize('width'),
	            height: this.frame.getSize('height')
	          };
	        }
	      }
	
	      if (fullSize) {
	        return dimensions;
	      } else {
	        return dimensions[this.options.axis === 'x' ? 'width' : 'height'];
	      }
	    }
	  }, {
	    key: 'getTrackSize',
	    value: function getTrackSize() {
	      var includeLastSlide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      var lastIndex = includeLastSlide ? this.views.length : this.views.length - 1;
	      var size = 0;
	      this.views.slice(0, lastIndex).forEach(function (view) {
	        size += view.getSize();
	      });
	      return size;
	    }
	  }, {
	    key: 'getView',
	    value: function getView(index) {
	      return this.views[(0, _utils.modulo)(index, this.views.length)];
	    }
	
	    // where the view should start
	
	  }, {
	    key: 'getStartCoords',
	    value: function getStartCoords(index) {
	      var target = 0;
	      this.views.slice(0, index).forEach(function (view) {
	        target -= view.getSize();
	      });
	      return target;
	    }
	
	    // how much to offset the view defined by the align option
	
	  }, {
	    key: 'getAlignOffset',
	    value: function getAlignOffset(view) {
	      var frameSize = this.getFrameSize({ autoSize: false });
	      var viewSize = view.getSize();
	      return (frameSize - viewSize) * this.options.align;
	    }
	  }, {
	    key: 'getPositionValue',
	    value: function getPositionValue() {
	      var trackPosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.trackPosition;
	      var _options5 = this.options,
	          infinite = _options5.infinite,
	          contain = _options5.contain;
	
	      var position = { x: 0, y: 0 };
	
	      // store the current animated value so we can reference it later
	      this.currentTween = trackPosition;
	
	      // wrap the track position if this is an infinite track
	      if (infinite) {
	        var trackSize = this.getTrackSize();
	        trackPosition = (0, _utils.modulo)(trackPosition, -trackSize) || 0;
	      }
	
	      // emit a "scroll" event so we can do things based on the progress of the track
	      this.emit('scroll', {
	        progress: trackPosition / this.getTrackSize(false),
	        position: trackPosition
	      });
	
	      // set the proper transform axis based on our options
	      position[this.options.axis] = trackPosition;
	
	      return position;
	    }
	  }, {
	    key: 'resetViewIndex',
	    value: function resetViewIndex() {
	      // reset back to a normal index
	      this.setCurrentView({
	        index: (0, _utils.modulo)(this.currentIndex, this.views.length),
	        suppressEvent: true
	      });
	    }
	  }]);
	
	  return Pager;
	}();
	
	exports.default = Pager;
	module.exports = exports['default'];

/***/ }),

/***/ 961:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PagerElement = function () {
	  function PagerElement(_ref) {
	    var node = _ref.node,
	        pager = _ref.pager,
	        width = _ref.width,
	        height = _ref.height;
	
	    _classCallCheck(this, PagerElement);
	
	    this.node = node;
	    this.pager = pager;
	    this.x = this.y = 0;
	    this.setSize(width, height);
	  }
	
	  _createClass(PagerElement, [{
	    key: 'setSize',
	    value: function setSize(width, height) {
	      this.width = width || this.node.offsetWidth;
	      this.height = height || this.node.offsetHeight;
	    }
	  }, {
	    key: 'setPosition',
	    value: function setPosition(position) {
	      this[this.pager.options.axis] = position;
	    }
	  }, {
	    key: 'getSize',
	    value: function getSize(dimension) {
	      if (dimension === 'width' || dimension === 'height') {
	        return this[dimension];
	      } else {
	        var axis = this.pager.options.axis;
	        return this[axis === 'x' ? 'width' : 'height'];
	      }
	    }
	  }, {
	    key: 'getPosition',
	    value: function getPosition() {
	      return this[this.pager.options.axis];
	    }
	  }]);
	
	  return PagerElement;
	}();
	
	exports.default = PagerElement;
	module.exports = exports['default'];

/***/ }),

/***/ 962:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function getTouchEvent(e) {
	  return e.touches && e.touches[0] || e;
	}
	
	var Swipe = function () {
	  function Swipe(pager) {
	    var _this = this;
	
	    _classCallCheck(this, Swipe);
	
	    this._onSwipeStart = function (e) {
	      var _getTouchEvent = getTouchEvent(e),
	          pageX = _getTouchEvent.pageX,
	          pageY = _getTouchEvent.pageY;
	
	      // we're now swiping
	
	
	      _this.pager.isSwiping = true;
	
	      // store the initial starting coordinates
	      _this._swipeStart = {
	        x: pageX,
	        y: pageY
	      };
	
	      // reset swipeDiff
	      _this._swipeDiff = {
	        x: 0,
	        y: 0
	      };
	
	      // determine if a flick or not
	      _this._isFlick = true;
	
	      setTimeout(function () {
	        _this._isFlick = false;
	      }, _this.pager.options.flickTimeout);
	
	      _this.pager.emit('swipeStart');
	    };
	
	    this._onSwipeMove = function (e) {
	      // bail if we aren't swiping
	      if (!_this.pager.isSwiping) return;
	
	      var _pager$options = _this.pager.options,
	          swipeThreshold = _pager$options.swipeThreshold,
	          axis = _pager$options.axis;
	
	      var _getTouchEvent2 = getTouchEvent(e),
	          pageX = _getTouchEvent2.pageX,
	          pageY = _getTouchEvent2.pageY;
	
	      // grab the current position of the track before
	
	
	      if (!_this._trackStart) {
	        _this._trackStart = _this.pager.currentTween;
	      }
	
	      // determine how much we have moved
	      _this._swipeDiff = {
	        x: _this._swipeStart.x - pageX,
	        y: _this._swipeStart.y - pageY
	      };
	
	      if (_this._isSwipe(swipeThreshold)) {
	        e.preventDefault();
	        e.stopPropagation();
	
	        var swipeDiff = _this._swipeDiff[axis];
	        var trackPosition = _this._trackStart - swipeDiff;
	
	        _this.pager.setPositionValue(trackPosition);
	
	        _this.pager.emit('swipeMove');
	      }
	    };
	
	    this._onSwipeEnd = function () {
	      var _pager$options2 = _this.pager.options,
	          swipeThreshold = _pager$options2.swipeThreshold,
	          viewsToMove = _pager$options2.viewsToMove,
	          axis = _pager$options2.axis,
	          infinite = _pager$options2.infinite;
	
	      var threshold = _this._isFlick ? swipeThreshold : _this.pager.currentView.getSize() * viewsToMove * swipeThreshold;
	
	      // we've stopped swiping
	      _this.pager.isSwiping = false;
	
	      // reset start track so we can grab it again on the next swipe
	      _this._trackStart = false;
	
	      // don't move anything if there hasn't been an attempted swipe
	      if (_this._swipeDiff.x || _this._swipeDiff.y) {
	        // determine if we've passed the defined threshold
	        if (_this._isSwipe(threshold)) {
	          if (_this._swipeDiff[axis] < 0) {
	            _this.pager.prev();
	          } else {
	            _this.pager.next();
	          }
	        }
	        // if we didn't, reset back to original view
	        else {
	            _this.pager.setPositionValue();
	          }
	      }
	
	      _this.pager.emit('swipeEnd');
	    };
	
	    this._onSwipePast = function () {
	      // perform a swipe end if we swiped past the component
	      if (_this.pager.isSwiping) {
	        _this._onSwipeEnd();
	      }
	    };
	
	    this.pager = pager;
	    this._trackStart = false;
	    this._swipeStart = this._swipeDiff = {
	      x: 0,
	      y: 0
	    };
	  }
	
	  _createClass(Swipe, [{
	    key: '_isSwipe',
	    value: function _isSwipe(threshold) {
	      var _swipeDiff = this._swipeDiff,
	          x = _swipeDiff.x,
	          y = _swipeDiff.y;
	
	      return this.pager.options.axis === 'x' ? Math.abs(x) > Math.max(threshold, Math.abs(y)) : Math.abs(x) < Math.max(threshold, Math.abs(y));
	    }
	  }, {
	    key: 'getEvents',
	    value: function getEvents() {
	      var swipe = this.pager.options.swipe;
	
	      var swipeEvents = {};
	
	      if (swipe === true || swipe === 'mouse') {
	        swipeEvents.onMouseDown = this._onSwipeStart;
	        swipeEvents.onMouseMove = this._onSwipeMove;
	        swipeEvents.onMouseUp = this._onSwipeEnd;
	        swipeEvents.onMouseLeave = this._onSwipePast;
	      }
	
	      if (swipe === true || swipe === 'touch') {
	        swipeEvents.onTouchStart = this._onSwipeStart;
	        swipeEvents.onTouchMove = this._onSwipeMove;
	        swipeEvents.onTouchEnd = this._onSwipeEnd;
	      }
	
	      return swipeEvents;
	    }
	  }]);
	
	  return Swipe;
	}();
	
	exports.default = Swipe;
	module.exports = exports['default'];

/***/ }),

/***/ 963:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(25);
	
	var _reactMotion = __webpack_require__(412);
	
	var _Pager = __webpack_require__(139);
	
	var _Pager2 = _interopRequireDefault(_Pager);
	
	var _getIndex = __webpack_require__(966);
	
	var _getIndex2 = _interopRequireDefault(_getIndex);
	
	var _specialAssign = __webpack_require__(307);
	
	var _specialAssign2 = _interopRequireDefault(_specialAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var noop = function noop() {
	  return null;
	};
	var checkedProps = {
	  tag: _propTypes2.default.any,
	  currentView: _propTypes2.default.any,
	  viewsToShow: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['auto'])]),
	  viewsToMove: _propTypes2.default.number,
	  align: _propTypes2.default.number,
	  contain: _propTypes2.default.bool,
	  axis: _propTypes2.default.oneOf(['x', 'y']),
	  animations: _propTypes2.default.array,
	  infinite: _propTypes2.default.bool,
	  instant: _propTypes2.default.bool,
	  swipe: _propTypes2.default.oneOf([true, false, 'mouse', 'touch']),
	  swipeThreshold: _propTypes2.default.number,
	  flickTimeout: _propTypes2.default.number,
	  // rightToLeft: PropTypes.bool,
	  // lazyLoad: PropTypes.bool,
	  springConfig: _propTypes2.default.objectOf(_propTypes2.default.number),
	  onSwipeStart: _propTypes2.default.func,
	  onSwipeMove: _propTypes2.default.func,
	  onSwipeEnd: _propTypes2.default.func,
	  onScroll: _propTypes2.default.func,
	  onViewChange: _propTypes2.default.func,
	  onRest: _propTypes2.default.func
	};
	var isNotEqual = function isNotEqual(current, next) {
	  return current.viewsToShow !== next.viewsToShow || current.viewsToMove !== next.viewsToMove || current.align !== next.align || current.axis !== next.axis || current.animations !== next.animations || current.infinite !== next.infinite || current.swipe !== next.swipe || current.swipeThreshold !== next.swipeThreshold || current.flickTimeout !== next.flickTimeout;
	};
	
	// Track scroller is an intermediate component that allows us to provide the
	// React Motion value to onScroll and lets any user of onScroll use setState
	
	var TrackScroller = function (_Component) {
	  _inherits(TrackScroller, _Component);
	
	  function TrackScroller() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TrackScroller);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TrackScroller.__proto__ || Object.getPrototypeOf(TrackScroller)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      x: 0,
	      y: 0
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TrackScroller, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(_ref2) {
	      var _this2 = this;
	
	      var trackPosition = _ref2.trackPosition;
	      var pager = this.context.pager;
	
	      // update view styles with current position tween
	      // this method can get called hundreds of times, let's make sure to optimize as much as we can
	
	      pager.setViewStyles(trackPosition);
	
	      // update onScroll callback, we use requestAnimationFrame to avoid bouncing
	      // back from updates from onScroll while React Motion is trying to update it's own tree
	      // https://github.com/chenglou/react-motion/issues/357#issuecomment-262393424
	      if (this.props.trackPosition !== trackPosition) {
	        requestAnimationFrame(function () {
	          return _this2.props.onScroll(trackPosition / pager.getTrackSize(false) * -1, trackPosition);
	        });
	      }
	    }
	  }, {
	    key: '_renderViews',
	    value: function _renderViews() {
	      // we need Children map in order for the infinite option to work
	      // not actually sure why this is the case
	      return _react.Children.map(this.props.children, function (child) {
	        return child;
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var pager = this.context.pager;
	
	      var _props = this.props,
	          tag = _props.tag,
	          trackPosition = _props.trackPosition,
	          children = _props.children,
	          restProps = _objectWithoutProperties(_props, ['tag', 'trackPosition', 'children']);
	
	      var style = _extends({}, restProps.style);
	
	      if (pager.track) {
	        style = _extends({}, style, pager.track.getStyles(trackPosition));
	      }
	
	      return (0, _react.createElement)(tag, _extends({}, restProps, {
	        style: style
	      }), this._renderViews());
	    }
	  }]);
	
	  return TrackScroller;
	}(_react.Component);
	
	TrackScroller.propTypes = checkedProps;
	TrackScroller.contextTypes = {
	  pager: _propTypes2.default.instanceOf(_Pager2.default)
	};
	
	var Track = function (_Component2) {
	  _inherits(Track, _Component2);
	
	  function Track() {
	    var _ref3;
	
	    var _temp2, _this3, _ret2;
	
	    _classCallCheck(this, Track);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref3 = Track.__proto__ || Object.getPrototypeOf(Track)).call.apply(_ref3, [this].concat(args))), _this3), _this3.state = {
	      instant: false
	    }, _this3._currentTween = 0, _this3._hydrate = false, _this3._handleOnRest = function () {
	      if (_this3.props.infinite && !_this3.state.instant) {
	        // reset back to a normal index
	        _this3.context.pager.resetViewIndex();
	
	        // set instant flag so we can prime track for next move
	        _this3._setValueInstantly(true, true);
	      }
	
	      _this3.props.onRest();
	    }, _temp2), _possibleConstructorReturn(_this3, _ret2);
	  }
	
	  _createClass(Track, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.context.pager.setOptions(this.props);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this4 = this;
	
	      var pager = this.context.pager;
	
	      // add track to pager
	
	      pager.addTrack((0, _reactDom.findDOMNode)(this));
	
	      // set initial view index and listen for any incoming view index changes
	      this.scrollTo((0, _getIndex2.default)(this.props.currentView, this.props.children));
	
	      // set values instantly on respective events
	      pager.on('hydrated', function () {
	        return _this4._setValueInstantly(true, true);
	      });
	      pager.on('swipeMove', function () {
	        return _this4._setValueInstantly(true);
	      });
	      pager.on('swipeEnd', function () {
	        return _this4._setValueInstantly(false);
	      });
	
	      // prop callbacks
	      pager.on('swipeStart', this.props.onSwipeStart);
	      pager.on('swipeMove', this.props.onSwipeMove);
	      pager.on('swipeEnd', this.props.onSwipeEnd);
	      pager.on('viewChange', this.props.onViewChange);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var currentView = nextProps.currentView,
	          instant = nextProps.instant,
	          children = nextProps.children;
	
	      // update instant state from props
	
	      if (this.props.instant !== instant) {
	        this._setValueInstantly(instant);
	      }
	
	      // update state with new index if necessary
	      if ((typeof currentView === 'undefined' ? 'undefined' : _typeof(currentView)) !== undefined && this.props.currentView !== currentView) {
	        this.scrollTo((0, _getIndex2.default)(currentView, children));
	      }
	
	      // update any options that have changed
	      if (isNotEqual(this.props, nextProps)) {
	        this.context.pager.setOptions(nextProps);
	        this._hydrate = true;
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(nextProps) {
	      if (this._hydrate) {
	        this.context.pager.hydrate();
	        this._hydrate = false;
	      }
	    }
	  }, {
	    key: 'prev',
	    value: function prev() {
	      this.context.pager.prev();
	    }
	  }, {
	    key: 'next',
	    value: function next() {
	      this.context.pager.next();
	    }
	  }, {
	    key: 'scrollTo',
	    value: function scrollTo(index) {
	      this.context.pager.setCurrentView({ index: index });
	    }
	  }, {
	    key: '_setValueInstantly',
	    value: function _setValueInstantly(instant, reset) {
	      var _this5 = this;
	
	      this.setState({ instant: instant }, function () {
	        if (reset) {
	          _this5.setState({ instant: false });
	        }
	      });
	    }
	  }, {
	    key: '_getTrackStyle',
	    value: function _getTrackStyle() {
	      var trackPosition = this.context.pager.trackPosition;
	
	      if (!this.state.instant) {
	        trackPosition = (0, _reactMotion.spring)(trackPosition, this.props.springConfig);
	      }
	      return { trackPosition: trackPosition };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          tag = _props2.tag,
	          onScroll = _props2.onScroll,
	          restProps = _objectWithoutProperties(_props2, ['tag', 'onScroll']);
	
	      return _react2.default.createElement(
	        _reactMotion.Motion,
	        {
	          style: this._getTrackStyle(),
	          onRest: this._handleOnRest
	        },
	        function (_ref4) {
	          var trackPosition = _ref4.trackPosition;
	          return (0, _react.createElement)(TrackScroller, (0, _specialAssign2.default)({ trackPosition: trackPosition, tag: tag, onScroll: onScroll }, restProps, checkedProps));
	        }
	      );
	    }
	  }]);
	
	  return Track;
	}(_react.Component);
	
	Track.propTypes = checkedProps;
	Track.defaultProps = {
	  tag: 'div',
	  currentView: 0,
	  viewsToShow: 1,
	  viewsToMove: 1,
	  align: 0,
	  contain: false,
	  axis: 'x',
	  infinite: false,
	  instant: false,
	  swipe: true,
	  swipeThreshold: 0.5,
	  flickTimeout: 300,
	  springConfig: _reactMotion.presets.noWobble,
	  onSwipeStart: noop,
	  onSwipeMove: noop,
	  onSwipeEnd: noop,
	  onScroll: noop,
	  onViewChange: noop,
	  onRest: noop
	};
	Track.contextTypes = {
	  pager: _propTypes2.default.instanceOf(_Pager2.default)
	};
	exports.default = Track;
	module.exports = exports['default'];

/***/ }),

/***/ 964:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(25);
	
	var _Pager = __webpack_require__(139);
	
	var _Pager2 = _interopRequireDefault(_Pager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var View = function (_Component) {
	  _inherits(View, _Component);
	
	  function View() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, View);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = View.__proto__ || Object.getPrototypeOf(View)).call.apply(_ref, [this].concat(args))), _this), _this._viewAdded = false, _this._viewInstance = null, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(View, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        view: this._viewInstance
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._viewInstance = this.context.pager.addView((0, _reactDom.findDOMNode)(this));
	      this._viewAdded = true;
	      this.forceUpdate();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.context.pager.removeView(this._viewInstance);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var pager = this.context.pager;
	      var _pager$options = pager.options,
	          viewsToShow = _pager$options.viewsToShow,
	          axis = _pager$options.axis;
	
	      var _props = this.props,
	          tag = _props.tag,
	          trackSize = _props.trackSize,
	          restProps = _objectWithoutProperties(_props, ['tag', 'trackSize']);
	
	      var style = _extends({}, restProps.style);
	
	      // hide view visually until it has been added to the pager
	      // this should help avoid FOUC
	      if (!this._viewAdded) {
	        style.visibility = 'hidden';
	        style.pointerEvents = 'none';
	      }
	
	      if (this._viewInstance) {
	        style = _extends({}, style, this._viewInstance.getStyles());
	      }
	
	      return (0, _react.createElement)(tag, _extends({}, restProps, { style: style }));
	    }
	  }]);
	
	  return View;
	}(_react.Component);
	
	View.contextTypes = {
	  pager: _propTypes2.default.instanceOf(_Pager2.default)
	};
	View.childContextTypes = {
	  view: _propTypes2.default.any
	};
	View.propTypes = {
	  tag: _propTypes2.default.any
	};
	View.defaultProps = {
	  tag: 'div'
	};
	exports.default = View;
	module.exports = exports['default'];

/***/ }),

/***/ 965:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Pager = __webpack_require__(139);
	
	var _Pager2 = _interopRequireDefault(_Pager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ViewPager = function (_Component) {
	  _inherits(ViewPager, _Component);
	
	  function ViewPager(props) {
	    _classCallCheck(this, ViewPager);
	
	    var _this = _possibleConstructorReturn(this, (ViewPager.__proto__ || Object.getPrototypeOf(ViewPager)).call(this, props));
	
	    var pager = new _Pager2.default();
	    var forceUpdate = function forceUpdate() {
	      return _this.forceUpdate();
	    };
	
	    // re-render the whole tree to update components on certain events
	    pager.on('viewChange', forceUpdate);
	    pager.on('hydrated', forceUpdate);
	
	    _this._pager = pager;
	    return _this;
	  }
	
	  _createClass(ViewPager, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        pager: this._pager
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      // run a hydration on the next animation frame to obtain proper targets and positioning
	      requestAnimationFrame(function () {
	        _this2._pager.hydrate();
	      });
	    }
	  }, {
	    key: 'getInstance',
	    value: function getInstance() {
	      return this._pager;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          tag = _props.tag,
	          restProps = _objectWithoutProperties(_props, ['tag']);
	
	      return (0, _react.createElement)(tag, restProps);
	    }
	  }]);
	
	  return ViewPager;
	}(_react.Component);
	
	ViewPager.childContextTypes = {
	  pager: _propTypes2.default.instanceOf(_Pager2.default)
	};
	ViewPager.propTypes = {
	  tag: _propTypes2.default.string
	};
	ViewPager.defaultProps = {
	  tag: 'div'
	};
	exports.default = ViewPager;
	module.exports = exports['default'];

/***/ }),

/***/ 966:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getIndex;
	
	var _react = __webpack_require__(1);
	
	function getIndex(key, children) {
	  var index = null;
	
	  _react.Children.forEach(children, function (child, _index) {
	    if (child.key === key || _index === key) {
	      index = _index;
	      return;
	    }
	  });
	
	  return index;
	}
	module.exports = exports['default'];

/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.utils = exports.AnimatedView = exports.View = exports.Track = exports.Frame = exports.ViewPager = undefined;
	
	var _ViewPager2 = __webpack_require__(965);
	
	var _ViewPager3 = _interopRequireDefault(_ViewPager2);
	
	var _Frame2 = __webpack_require__(959);
	
	var _Frame3 = _interopRequireDefault(_Frame2);
	
	var _Track2 = __webpack_require__(963);
	
	var _Track3 = _interopRequireDefault(_Track2);
	
	var _View2 = __webpack_require__(964);
	
	var _View3 = _interopRequireDefault(_View2);
	
	var _AnimatedView2 = __webpack_require__(958);
	
	var _AnimatedView3 = _interopRequireDefault(_AnimatedView2);
	
	var _utils2 = __webpack_require__(308);
	
	var _utils3 = _interopRequireDefault(_utils2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ViewPager = _ViewPager3.default;
	exports.Frame = _Frame3.default;
	exports.Track = _Track3.default;
	exports.View = _View3.default;
	exports.AnimatedView = _AnimatedView3.default;
	exports.utils = _utils3.default;

/***/ }),

/***/ 307:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = specialAssign;
	function specialAssign(a, b, reserved) {
	  for (var x in b) {
	    if (!b.hasOwnProperty(x) || reserved[x]) continue;
	    a[x] = b[x];
	  }
	  return a;
	}
	module.exports = exports["default"];

/***/ }),

/***/ 308:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.modulo = modulo;
	exports.clamp = clamp;
	exports.sum = sum;
	exports.max = max;
	exports.range = range;
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function modulo(val, max) {
	  return (val % max + max) % max;
	}
	
	function clamp(val, min, max) {
	  return Math.min(Math.max(min, val), max);
	}
	
	function sum(arr) {
	  return arr.reduce(function (a, b) {
	    return a + b;
	  }, 0);
	}
	
	function max(arr) {
	  return Math.max.apply(null, arr);
	}
	
	function range(start, end, max) {
	  return [].concat(_toConsumableArray(Array(1 + end - start))).map(function (val) {
	    return max ? modulo(start + val, max) : start + val;
	  });
	}

/***/ }),

/***/ 989:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	/**
	 * A collection of shims that provide minimal functionality of the ES6 collections.
	 *
	 * These implementations are not meant to be used outside of the ResizeObserver
	 * modules as they cover only a limited range of use cases.
	 */
	/* eslint-disable require-jsdoc, valid-jsdoc */
	var MapShim = (function () {
	    if (typeof Map !== 'undefined') {
	        return Map;
	    }
	
	    /**
	     * Returns index in provided array that matches the specified key.
	     *
	     * @param {Array<Array>} arr
	     * @param {*} key
	     * @returns {number}
	     */
	    function getIndex(arr, key) {
	        var result = -1;
	
	        arr.some(function (entry, index) {
	            if (entry[0] === key) {
	                result = index;
	
	                return true;
	            }
	
	            return false;
	        });
	
	        return result;
	    }
	
	    return (function () {
	        function anonymous() {
	            this.__entries__ = [];
	        }
	
	        var prototypeAccessors = { size: { configurable: true } };
	
	        /**
	         * @returns {boolean}
	         */
	        prototypeAccessors.size.get = function () {
	            return this.__entries__.length;
	        };
	
	        /**
	         * @param {*} key
	         * @returns {*}
	         */
	        anonymous.prototype.get = function (key) {
	            var index = getIndex(this.__entries__, key);
	            var entry = this.__entries__[index];
	
	            return entry && entry[1];
	        };
	
	        /**
	         * @param {*} key
	         * @param {*} value
	         * @returns {void}
	         */
	        anonymous.prototype.set = function (key, value) {
	            var index = getIndex(this.__entries__, key);
	
	            if (~index) {
	                this.__entries__[index][1] = value;
	            } else {
	                this.__entries__.push([key, value]);
	            }
	        };
	
	        /**
	         * @param {*} key
	         * @returns {void}
	         */
	        anonymous.prototype.delete = function (key) {
	            var entries = this.__entries__;
	            var index = getIndex(entries, key);
	
	            if (~index) {
	                entries.splice(index, 1);
	            }
	        };
	
	        /**
	         * @param {*} key
	         * @returns {void}
	         */
	        anonymous.prototype.has = function (key) {
	            return !!~getIndex(this.__entries__, key);
	        };
	
	        /**
	         * @returns {void}
	         */
	        anonymous.prototype.clear = function () {
	            this.__entries__.splice(0);
	        };
	
	        /**
	         * @param {Function} callback
	         * @param {*} [ctx=null]
	         * @returns {void}
	         */
	        anonymous.prototype.forEach = function (callback, ctx) {
	            var this$1 = this;
	            if ( ctx === void 0 ) ctx = null;
	
	            for (var i = 0, list = this$1.__entries__; i < list.length; i += 1) {
	                var entry = list[i];
	
	                callback.call(ctx, entry[1], entry[0]);
	            }
	        };
	
	        Object.defineProperties( anonymous.prototype, prototypeAccessors );
	
	        return anonymous;
	    }());
	})();
	
	/**
	 * Detects whether window and document objects are available in current environment.
	 */
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	// Returns global object of a current environment.
	var global$1 = (function () {
	    if (typeof global !== 'undefined' && global.Math === Math) {
	        return global;
	    }
	
	    if (typeof self !== 'undefined' && self.Math === Math) {
	        return self;
	    }
	
	    if (typeof window !== 'undefined' && window.Math === Math) {
	        return window;
	    }
	
	    // eslint-disable-next-line no-new-func
	    return Function('return this')();
	})();
	
	/**
	 * A shim for the requestAnimationFrame which falls back to the setTimeout if
	 * first one is not supported.
	 *
	 * @returns {number} Requests' identifier.
	 */
	var requestAnimationFrame$1 = (function () {
	    if (typeof requestAnimationFrame === 'function') {
	        // It's required to use a bounded function because IE sometimes throws
	        // an "Invalid calling object" error if rAF is invoked without the global
	        // object on the left hand side.
	        return requestAnimationFrame.bind(global$1);
	    }
	
	    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	})();
	
	// Defines minimum timeout before adding a trailing call.
	var trailingTimeout = 2;
	
	/**
	 * Creates a wrapper function which ensures that provided callback will be
	 * invoked only once during the specified delay period.
	 *
	 * @param {Function} callback - Function to be invoked after the delay period.
	 * @param {number} delay - Delay after which to invoke callback.
	 * @returns {Function}
	 */
	var throttle = function (callback, delay) {
	    var leadingCall = false,
	        trailingCall = false,
	        lastCallTime = 0;
	
	    /**
	     * Invokes the original callback function and schedules new invocation if
	     * the "proxy" was called during current request.
	     *
	     * @returns {void}
	     */
	    function resolvePending() {
	        if (leadingCall) {
	            leadingCall = false;
	
	            callback();
	        }
	
	        if (trailingCall) {
	            proxy();
	        }
	    }
	
	    /**
	     * Callback invoked after the specified delay. It will further postpone
	     * invocation of the original function delegating it to the
	     * requestAnimationFrame.
	     *
	     * @returns {void}
	     */
	    function timeoutCallback() {
	        requestAnimationFrame$1(resolvePending);
	    }
	
	    /**
	     * Schedules invocation of the original function.
	     *
	     * @returns {void}
	     */
	    function proxy() {
	        var timeStamp = Date.now();
	
	        if (leadingCall) {
	            // Reject immediately following calls.
	            if (timeStamp - lastCallTime < trailingTimeout) {
	                return;
	            }
	
	            // Schedule new call to be in invoked when the pending one is resolved.
	            // This is important for "transitions" which never actually start
	            // immediately so there is a chance that we might miss one if change
	            // happens amids the pending invocation.
	            trailingCall = true;
	        } else {
	            leadingCall = true;
	            trailingCall = false;
	
	            setTimeout(timeoutCallback, delay);
	        }
	
	        lastCallTime = timeStamp;
	    }
	
	    return proxy;
	};
	
	// Minimum delay before invoking the update of observers.
	var REFRESH_DELAY = 20;
	
	// A list of substrings of CSS properties used to find transition events that
	// might affect dimensions of observed elements.
	var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	
	// Check if MutationObserver is available.
	var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	
	/**
	 * Singleton controller class which handles updates of ResizeObserver instances.
	 */
	var ResizeObserverController = function() {
	    this.connected_ = false;
	    this.mutationEventsAdded_ = false;
	    this.mutationsObserver_ = null;
	    this.observers_ = [];
	
	    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	};
	
	/**
	 * Adds observer to observers list.
	 *
	 * @param {ResizeObserverSPI} observer - Observer to be added.
	 * @returns {void}
	 */
	
	
	/**
	 * Holds reference to the controller's instance.
	 *
	 * @private {ResizeObserverController}
	 */
	
	
	/**
	 * Keeps reference to the instance of MutationObserver.
	 *
	 * @private {MutationObserver}
	 */
	
	/**
	 * Indicates whether DOM listeners have been added.
	 *
	 * @private {boolean}
	 */
	ResizeObserverController.prototype.addObserver = function (observer) {
	    if (!~this.observers_.indexOf(observer)) {
	        this.observers_.push(observer);
	    }
	
	    // Add listeners if they haven't been added yet.
	    if (!this.connected_) {
	        this.connect_();
	    }
	};
	
	/**
	 * Removes observer from observers list.
	 *
	 * @param {ResizeObserverSPI} observer - Observer to be removed.
	 * @returns {void}
	 */
	ResizeObserverController.prototype.removeObserver = function (observer) {
	    var observers = this.observers_;
	    var index = observers.indexOf(observer);
	
	    // Remove observer if it's present in registry.
	    if (~index) {
	        observers.splice(index, 1);
	    }
	
	    // Remove listeners if controller has no connected observers.
	    if (!observers.length && this.connected_) {
	        this.disconnect_();
	    }
	};
	
	/**
	 * Invokes the update of observers. It will continue running updates insofar
	 * it detects changes.
	 *
	 * @returns {void}
	 */
	ResizeObserverController.prototype.refresh = function () {
	    var changesDetected = this.updateObservers_();
	
	    // Continue running updates if changes have been detected as there might
	    // be future ones caused by CSS transitions.
	    if (changesDetected) {
	        this.refresh();
	    }
	};
	
	/**
	 * Updates every observer from observers list and notifies them of queued
	 * entries.
	 *
	 * @private
	 * @returns {boolean} Returns "true" if any observer has detected changes in
	 *  dimensions of it's elements.
	 */
	ResizeObserverController.prototype.updateObservers_ = function () {
	    // Collect observers that have active observations.
	    var activeObservers = this.observers_.filter(function (observer) {
	        return observer.gatherActive(), observer.hasActive();
	    });
	
	    // Deliver notifications in a separate cycle in order to avoid any
	    // collisions between observers, e.g. when multiple instances of
	    // ResizeObserver are tracking the same element and the callback of one
	    // of them changes content dimensions of the observed target. Sometimes
	    // this may result in notifications being blocked for the rest of observers.
	    activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	
	    return activeObservers.length > 0;
	};
	
	/**
	 * Initializes DOM listeners.
	 *
	 * @private
	 * @returns {void}
	 */
	ResizeObserverController.prototype.connect_ = function () {
	    // Do nothing if running in a non-browser environment or if listeners
	    // have been already added.
	    if (!isBrowser || this.connected_) {
	        return;
	    }
	
	    // Subscription to the "Transitionend" event is used as a workaround for
	    // delayed transitions. This way it's possible to capture at least the
	    // final state of an element.
	    document.addEventListener('transitionend', this.onTransitionEnd_);
	
	    window.addEventListener('resize', this.refresh);
	
	    if (mutationObserverSupported) {
	        this.mutationsObserver_ = new MutationObserver(this.refresh);
	
	        this.mutationsObserver_.observe(document, {
	            attributes: true,
	            childList: true,
	            characterData: true,
	            subtree: true
	        });
	    } else {
	        document.addEventListener('DOMSubtreeModified', this.refresh);
	
	        this.mutationEventsAdded_ = true;
	    }
	
	    this.connected_ = true;
	};
	
	/**
	 * Removes DOM listeners.
	 *
	 * @private
	 * @returns {void}
	 */
	ResizeObserverController.prototype.disconnect_ = function () {
	    // Do nothing if running in a non-browser environment or if listeners
	    // have been already removed.
	    if (!isBrowser || !this.connected_) {
	        return;
	    }
	
	    document.removeEventListener('transitionend', this.onTransitionEnd_);
	    window.removeEventListener('resize', this.refresh);
	
	    if (this.mutationsObserver_) {
	        this.mutationsObserver_.disconnect();
	    }
	
	    if (this.mutationEventsAdded_) {
	        document.removeEventListener('DOMSubtreeModified', this.refresh);
	    }
	
	    this.mutationsObserver_ = null;
	    this.mutationEventsAdded_ = false;
	    this.connected_ = false;
	};
	
	/**
	 * "Transitionend" event handler.
	 *
	 * @private
	 * @param {TransitionEvent} event
	 * @returns {void}
	 */
	ResizeObserverController.prototype.onTransitionEnd_ = function (ref) {
	        var propertyName = ref.propertyName; if ( propertyName === void 0 ) propertyName = '';
	
	    // Detect whether transition may affect dimensions of an element.
	    var isReflowProperty = transitionKeys.some(function (key) {
	        return !!~propertyName.indexOf(key);
	    });
	
	    if (isReflowProperty) {
	        this.refresh();
	    }
	};
	
	/**
	 * Returns instance of the ResizeObserverController.
	 *
	 * @returns {ResizeObserverController}
	 */
	ResizeObserverController.getInstance = function () {
	    if (!this.instance_) {
	        this.instance_ = new ResizeObserverController();
	    }
	
	    return this.instance_;
	};
	
	ResizeObserverController.instance_ = null;
	
	/**
	 * Defines non-writable/enumerable properties of the provided target object.
	 *
	 * @param {Object} target - Object for which to define properties.
	 * @param {Object} props - Properties to be defined.
	 * @returns {Object} Target object.
	 */
	var defineConfigurable = (function (target, props) {
	    for (var i = 0, list = Object.keys(props); i < list.length; i += 1) {
	        var key = list[i];
	
	        Object.defineProperty(target, key, {
	            value: props[key],
	            enumerable: false,
	            writable: false,
	            configurable: true
	        });
	    }
	
	    return target;
	});
	
	/**
	 * Returns the global object associated with provided element.
	 *
	 * @param {Object} target
	 * @returns {Object}
	 */
	var getWindowOf = (function (target) {
	    // Assume that the element is an instance of Node, which means that it
	    // has the "ownerDocument" property from which we can retrieve a
	    // corresponding global object.
	    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	
	    // Return the local global object if it's not possible extract one from
	    // provided element.
	    return ownerGlobal || global$1;
	});
	
	// Placeholder of an empty content rectangle.
	var emptyRect = createRectInit(0, 0, 0, 0);
	
	/**
	 * Converts provided string to a number.
	 *
	 * @param {number|string} value
	 * @returns {number}
	 */
	function toFloat(value) {
	    return parseFloat(value) || 0;
	}
	
	/**
	 * Extracts borders size from provided styles.
	 *
	 * @param {CSSStyleDeclaration} styles
	 * @param {...string} positions - Borders positions (top, right, ...)
	 * @returns {number}
	 */
	function getBordersSize(styles) {
	    var positions = [], len = arguments.length - 1;
	    while ( len-- > 0 ) positions[ len ] = arguments[ len + 1 ];
	
	    return positions.reduce(function (size, position) {
	        var value = styles['border-' + position + '-width'];
	
	        return size + toFloat(value);
	    }, 0);
	}
	
	/**
	 * Extracts paddings sizes from provided styles.
	 *
	 * @param {CSSStyleDeclaration} styles
	 * @returns {Object} Paddings box.
	 */
	function getPaddings(styles) {
	    var positions = ['top', 'right', 'bottom', 'left'];
	    var paddings = {};
	
	    for (var i = 0, list = positions; i < list.length; i += 1) {
	        var position = list[i];
	
	        var value = styles['padding-' + position];
	
	        paddings[position] = toFloat(value);
	    }
	
	    return paddings;
	}
	
	/**
	 * Calculates content rectangle of provided SVG element.
	 *
	 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	 *      to be calculated.
	 * @returns {DOMRectInit}
	 */
	function getSVGContentRect(target) {
	    var bbox = target.getBBox();
	
	    return createRectInit(0, 0, bbox.width, bbox.height);
	}
	
	/**
	 * Calculates content rectangle of provided HTMLElement.
	 *
	 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	 * @returns {DOMRectInit}
	 */
	function getHTMLElementContentRect(target) {
	    // Client width & height properties can't be
	    // used exclusively as they provide rounded values.
	    var clientWidth = target.clientWidth;
	    var clientHeight = target.clientHeight;
	
	    // By this condition we can catch all non-replaced inline, hidden and
	    // detached elements. Though elements with width & height properties less
	    // than 0.5 will be discarded as well.
	    //
	    // Without it we would need to implement separate methods for each of
	    // those cases and it's not possible to perform a precise and performance
	    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	    // gives wrong results for elements with width & height less than 0.5.
	    if (!clientWidth && !clientHeight) {
	        return emptyRect;
	    }
	
	    var styles = getWindowOf(target).getComputedStyle(target);
	    var paddings = getPaddings(styles);
	    var horizPad = paddings.left + paddings.right;
	    var vertPad = paddings.top + paddings.bottom;
	
	    // Computed styles of width & height are being used because they are the
	    // only dimensions available to JS that contain non-rounded values. It could
	    // be possible to utilize the getBoundingClientRect if only it's data wasn't
	    // affected by CSS transformations let alone paddings, borders and scroll bars.
	    var width = toFloat(styles.width),
	        height = toFloat(styles.height);
	
	    // Width & height include paddings and borders when the 'border-box' box
	    // model is applied (except for IE).
	    if (styles.boxSizing === 'border-box') {
	        // Following conditions are required to handle Internet Explorer which
	        // doesn't include paddings and borders to computed CSS dimensions.
	        //
	        // We can say that if CSS dimensions + paddings are equal to the "client"
	        // properties then it's either IE, and thus we don't need to subtract
	        // anything, or an element merely doesn't have paddings/borders styles.
	        if (Math.round(width + horizPad) !== clientWidth) {
	            width -= getBordersSize(styles, 'left', 'right') + horizPad;
	        }
	
	        if (Math.round(height + vertPad) !== clientHeight) {
	            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	        }
	    }
	
	    // Following steps can't be applied to the document's root element as its
	    // client[Width/Height] properties represent viewport area of the window.
	    // Besides, it's as well not necessary as the <html> itself neither has
	    // rendered scroll bars nor it can be clipped.
	    if (!isDocumentElement(target)) {
	        // In some browsers (only in Firefox, actually) CSS width & height
	        // include scroll bars size which can be removed at this step as scroll
	        // bars are the only difference between rounded dimensions + paddings
	        // and "client" properties, though that is not always true in Chrome.
	        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	
	        // Chrome has a rather weird rounding of "client" properties.
	        // E.g. for an element with content width of 314.2px it sometimes gives
	        // the client width of 315px and for the width of 314.7px it may give
	        // 314px. And it doesn't happen all the time. So just ignore this delta
	        // as a non-relevant.
	        if (Math.abs(vertScrollbar) !== 1) {
	            width -= vertScrollbar;
	        }
	
	        if (Math.abs(horizScrollbar) !== 1) {
	            height -= horizScrollbar;
	        }
	    }
	
	    return createRectInit(paddings.left, paddings.top, width, height);
	}
	
	/**
	 * Checks whether provided element is an instance of the SVGGraphicsElement.
	 *
	 * @param {Element} target - Element to be checked.
	 * @returns {boolean}
	 */
	var isSVGGraphicsElement = (function () {
	    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	    // interface.
	    if (typeof SVGGraphicsElement !== 'undefined') {
	        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	    }
	
	    // If it's so, then check that element is at least an instance of the
	    // SVGElement and that it has the "getBBox" method.
	    // eslint-disable-next-line no-extra-parens
	    return function (target) { return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function'; };
	})();
	
	/**
	 * Checks whether provided element is a document element (<html>).
	 *
	 * @param {Element} target - Element to be checked.
	 * @returns {boolean}
	 */
	function isDocumentElement(target) {
	    return target === getWindowOf(target).document.documentElement;
	}
	
	/**
	 * Calculates an appropriate content rectangle for provided html or svg element.
	 *
	 * @param {Element} target - Element content rectangle of which needs to be calculated.
	 * @returns {DOMRectInit}
	 */
	function getContentRect(target) {
	    if (!isBrowser) {
	        return emptyRect;
	    }
	
	    if (isSVGGraphicsElement(target)) {
	        return getSVGContentRect(target);
	    }
	
	    return getHTMLElementContentRect(target);
	}
	
	/**
	 * Creates rectangle with an interface of the DOMRectReadOnly.
	 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	 *
	 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	 * @returns {DOMRectReadOnly}
	 */
	function createReadOnlyRect(ref) {
	    var x = ref.x;
	    var y = ref.y;
	    var width = ref.width;
	    var height = ref.height;
	
	    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	    var rect = Object.create(Constr.prototype);
	
	    // Rectangle's properties are not writable and non-enumerable.
	    defineConfigurable(rect, {
	        x: x, y: y, width: width, height: height,
	        top: y,
	        right: x + width,
	        bottom: height + y,
	        left: x
	    });
	
	    return rect;
	}
	
	/**
	 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	 *
	 * @param {number} x - X coordinate.
	 * @param {number} y - Y coordinate.
	 * @param {number} width - Rectangle's width.
	 * @param {number} height - Rectangle's height.
	 * @returns {DOMRectInit}
	 */
	function createRectInit(x, y, width, height) {
	    return { x: x, y: y, width: width, height: height };
	}
	
	/**
	 * Class that is responsible for computations of the content rectangle of
	 * provided DOM element and for keeping track of it's changes.
	 */
	var ResizeObservation = function(target) {
	    this.broadcastWidth = 0;
	    this.broadcastHeight = 0;
	    this.contentRect_ = createRectInit(0, 0, 0, 0);
	
	    this.target = target;
	};
	
	/**
	 * Updates content rectangle and tells whether it's width or height properties
	 * have changed since the last broadcast.
	 *
	 * @returns {boolean}
	 */
	
	
	/**
	 * Reference to the last observed content rectangle.
	 *
	 * @private {DOMRectInit}
	 */
	
	
	/**
	 * Broadcasted width of content rectangle.
	 *
	 * @type {number}
	 */
	ResizeObservation.prototype.isActive = function () {
	    var rect = getContentRect(this.target);
	
	    this.contentRect_ = rect;
	
	    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
	};
	
	/**
	 * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	 * from the corresponding properties of the last observed content rectangle.
	 *
	 * @returns {DOMRectInit} Last observed content rectangle.
	 */
	ResizeObservation.prototype.broadcastRect = function () {
	    var rect = this.contentRect_;
	
	    this.broadcastWidth = rect.width;
	    this.broadcastHeight = rect.height;
	
	    return rect;
	};
	
	var ResizeObserverEntry = function(target, rectInit) {
	    var contentRect = createReadOnlyRect(rectInit);
	
	    // According to the specification following properties are not writable
	    // and are also not enumerable in the native implementation.
	    //
	    // Property accessors are not being used as they'd require to define a
	    // private WeakMap storage which may cause memory leaks in browsers that
	    // don't support this type of collections.
	    defineConfigurable(this, { target: target, contentRect: contentRect });
	};
	
	var ResizeObserverSPI = function(callback, controller, callbackCtx) {
	    this.activeObservations_ = [];
	    this.observations_ = new MapShim();
	
	    if (typeof callback !== 'function') {
	        throw new TypeError('The callback provided as parameter 1 is not a function.');
	    }
	
	    this.callback_ = callback;
	    this.controller_ = controller;
	    this.callbackCtx_ = callbackCtx;
	};
	
	/**
	 * Starts observing provided element.
	 *
	 * @param {Element} target - Element to be observed.
	 * @returns {void}
	 */
	
	
	/**
	 * Registry of the ResizeObservation instances.
	 *
	 * @private {Map<Element, ResizeObservation>}
	 */
	
	
	/**
	 * Public ResizeObserver instance which will be passed to the callback
	 * function and used as a value of it's "this" binding.
	 *
	 * @private {ResizeObserver}
	 */
	
	/**
	 * Collection of resize observations that have detected changes in dimensions
	 * of elements.
	 *
	 * @private {Array<ResizeObservation>}
	 */
	ResizeObserverSPI.prototype.observe = function (target) {
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    // Do nothing if current environment doesn't have the Element interface.
	    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	        return;
	    }
	
	    if (!(target instanceof getWindowOf(target).Element)) {
	        throw new TypeError('parameter 1 is not of type "Element".');
	    }
	
	    var observations = this.observations_;
	
	    // Do nothing if element is already being observed.
	    if (observations.has(target)) {
	        return;
	    }
	
	    observations.set(target, new ResizeObservation(target));
	
	    this.controller_.addObserver(this);
	
	    // Force the update of observations.
	    this.controller_.refresh();
	};
	
	/**
	 * Stops observing provided element.
	 *
	 * @param {Element} target - Element to stop observing.
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.unobserve = function (target) {
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    // Do nothing if current environment doesn't have the Element interface.
	    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	        return;
	    }
	
	    if (!(target instanceof getWindowOf(target).Element)) {
	        throw new TypeError('parameter 1 is not of type "Element".');
	    }
	
	    var observations = this.observations_;
	
	    // Do nothing if element is not being observed.
	    if (!observations.has(target)) {
	        return;
	    }
	
	    observations.delete(target);
	
	    if (!observations.size) {
	        this.controller_.removeObserver(this);
	    }
	};
	
	/**
	 * Stops observing all elements.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.disconnect = function () {
	    this.clearActive();
	    this.observations_.clear();
	    this.controller_.removeObserver(this);
	};
	
	/**
	 * Collects observation instances the associated element of which has changed
	 * it's content rectangle.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.gatherActive = function () {
	        var this$1 = this;
	
	    this.clearActive();
	
	    this.observations_.forEach(function (observation) {
	        if (observation.isActive()) {
	            this$1.activeObservations_.push(observation);
	        }
	    });
	};
	
	/**
	 * Invokes initial callback function with a list of ResizeObserverEntry
	 * instances collected from active resize observations.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.broadcastActive = function () {
	    // Do nothing if observer doesn't have active observations.
	    if (!this.hasActive()) {
	        return;
	    }
	
	    var ctx = this.callbackCtx_;
	
	    // Create ResizeObserverEntry instance for every active observation.
	    var entries = this.activeObservations_.map(function (observation) {
	        return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	    });
	
	    this.callback_.call(ctx, entries, ctx);
	    this.clearActive();
	};
	
	/**
	 * Clears the collection of active observations.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.clearActive = function () {
	    this.activeObservations_.splice(0);
	};
	
	/**
	 * Tells whether observer has active observations.
	 *
	 * @returns {boolean}
	 */
	ResizeObserverSPI.prototype.hasActive = function () {
	    return this.activeObservations_.length > 0;
	};
	
	// Registry of internal observers. If WeakMap is not available use current shim
	// for the Map collection as it has all required methods and because WeakMap
	// can't be fully polyfilled anyway.
	var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	
	/**
	 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	 * exposing only those methods and properties that are defined in the spec.
	 */
	var ResizeObserver = function(callback) {
	    if (!(this instanceof ResizeObserver)) {
	        throw new TypeError('Cannot call a class as a function.');
	    }
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    var controller = ResizeObserverController.getInstance();
	    var observer = new ResizeObserverSPI(callback, controller, this);
	
	    observers.set(this, observer);
	};
	
	// Expose public methods of ResizeObserver.
	['observe', 'unobserve', 'disconnect'].forEach(function (method) {
	    ResizeObserver.prototype[method] = function () {
	        return (ref = observers.get(this))[method].apply(ref, arguments);
	        var ref;
	    };
	});
	
	var index = (function () {
	    // Export existing implementation if available.
	    if (typeof global$1.ResizeObserver !== 'undefined') {
	        return global$1.ResizeObserver;
	    }
	
	    return ResizeObserver;
	})();
	
	return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 1121:
/***/ (function(module, exports) {

	module.exports = function(el, options) {
	  options = options || {};
	
	  var elementDocument = el.ownerDocument || el;
	  var basicTabbables = [];
	  var orderedTabbables = [];
	
	  // A node is "available" if
	  // - it's computed style
	  var isUnavailable = createIsUnavailable(elementDocument);
	
	  var candidateSelectors = [
	    'input',
	    'select',
	    'a[href]',
	    'textarea',
	    'button',
	    '[tabindex]',
	  ];
	
	  var candidates = el.querySelectorAll(candidateSelectors.join(','));
	
	  if (options.includeContainer) {
	    var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
	
	    if (
	      candidateSelectors.some(function(candidateSelector) {
	        return matches.call(el, candidateSelector);
	      })
	    ) {
	      candidates = Array.prototype.slice.apply(candidates);
	      candidates.unshift(el);
	    }
	  }
	
	  var candidate, candidateIndex;
	  for (var i = 0, l = candidates.length; i < l; i++) {
	    candidate = candidates[i];
	    candidateIndex = parseInt(candidate.getAttribute('tabindex'), 10) || candidate.tabIndex;
	
	    if (
	      candidateIndex < 0
	      || (candidate.tagName === 'INPUT' && candidate.type === 'hidden')
	      || candidate.disabled
	      || isUnavailable(candidate, elementDocument)
	    ) {
	      continue;
	    }
	
	    if (candidateIndex === 0) {
	      basicTabbables.push(candidate);
	    } else {
	      orderedTabbables.push({
	        index: i,
	        tabIndex: candidateIndex,
	        node: candidate,
	      });
	    }
	  }
	
	  var tabbableNodes = orderedTabbables
	    .sort(function(a, b) {
	      return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
	    })
	    .map(function(a) {
	      return a.node
	    });
	
	  Array.prototype.push.apply(tabbableNodes, basicTabbables);
	
	  return tabbableNodes;
	}
	
	function createIsUnavailable(elementDocument) {
	  // Node cache must be refreshed on every check, in case
	  // the content of the element has changed
	  var isOffCache = [];
	
	  // "off" means `display: none;`, as opposed to "hidden",
	  // which means `visibility: hidden;`. getComputedStyle
	  // accurately reflects visiblity in context but not
	  // "off" state, so we need to recursively check parents.
	
	  function isOff(node, nodeComputedStyle) {
	    if (node === elementDocument.documentElement) return false;
	
	    // Find the cached node (Array.prototype.find not available in IE9)
	    for (var i = 0, length = isOffCache.length; i < length; i++) {
	      if (isOffCache[i][0] === node) return isOffCache[i][1];
	    }
	
	    nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);
	
	    var result = false;
	
	    if (nodeComputedStyle.display === 'none') {
	      result = true;
	    } else if (node.parentNode) {
	      result = isOff(node.parentNode);
	    }
	
	    isOffCache.push([node, result]);
	
	    return result;
	  }
	
	  return function isUnavailable(node) {
	    if (node === elementDocument.documentElement) return false;
	
	    var computedStyle = elementDocument.defaultView.getComputedStyle(node);
	
	    if (isOff(node, computedStyle)) return true;
	
	    return computedStyle.visibility === 'hidden';
	  }
	}


/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Callout;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(3);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _calloutModule = __webpack_require__(245);
	
	var _calloutModule2 = _interopRequireDefault(_calloutModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cx = _bind2.default.bind(_calloutModule2.default);
	var propTypes = {
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.node
	};
	
	function Callout(_ref) {
	  var className = _ref.className,
	      children = _ref.children;
	
	  return _react2.default.createElement(
	    'div',
	    { className: cx('callout', className) },
	    children
	  );
	}
	Callout.displayName = 'Callout';
	Callout.propTypes = propTypes;
	module.exports = exports['default'];

/***/ }),

/***/ 245:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"callout":"_1IUvJbReshQ1aH8u8yNTby"};

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Callout = __webpack_require__(204);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Callout).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _lodash = __webpack_require__(10);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bind = __webpack_require__(3);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _reactViewPager = __webpack_require__(440);
	
	var _homeModule = __webpack_require__(118);
	
	var _homeModule2 = _interopRequireDefault(_homeModule);
	
	var _ProgressPage = __webpack_require__(523);
	
	var _ProgressPage2 = _interopRequireDefault(_ProgressPage);
	
	var _banner = __webpack_require__(1123);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _banner3 = __webpack_require__(1124);
	
	var _banner4 = _interopRequireDefault(_banner3);
	
	var _banner5 = __webpack_require__(1125);
	
	var _banner6 = _interopRequireDefault(_banner5);
	
	var _carouselText = __webpack_require__(1129);
	
	var _carouselText2 = _interopRequireDefault(_carouselText);
	
	var _carouselText3 = __webpack_require__(1130);
	
	var _carouselText4 = _interopRequireDefault(_carouselText3);
	
	var _carouselText5 = __webpack_require__(1131);
	
	var _carouselText6 = _interopRequireDefault(_carouselText5);
	
	var _carouselLeft = __webpack_require__(1127);
	
	var _carouselLeft2 = _interopRequireDefault(_carouselLeft);
	
	var _carouselRight = __webpack_require__(1128);
	
	var _carouselRight2 = _interopRequireDefault(_carouselRight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cx = _bind2.default.bind(_homeModule2.default);
	var propTypes = {};
	var bannerTimeout = 4000;
	var banners = [_banner2.default, _banner4.default, _banner6.default],
	    copies = [_carouselText2.default, _carouselText4.default, _carouselText6.default];
	
	var Carousel = function (_PureComponent) {
	  _inherits(Carousel, _PureComponent);
	
	  function Carousel() {
	    _classCallCheck(this, Carousel);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args)));
	
	    _this.handleViewChange = function (indicies) {
	      return _this.setState({ currentView: indicies[0] });
	    };
	
	    _this.handleProgressClick = function (index) {
	      // this forces this component to re-render after view has finished
	      // scrolling. Otherwise we wouldn't need this state;
	      _this.setState({ currentView: index });
	    };
	
	    _this.handleScroll = function (progress) {
	      _this.setState({ progress: progress });
	    };
	
	    _this.frameRef = function (frame) {
	      _this.frame = frame;
	    };
	
	    _this._carouselItem = function (src, i) {
	      return _react2.default.createElement(
	        _reactViewPager.View,
	        { className: cx('pager-container'), key: src },
	        _react2.default.createElement('img', { alt: 'foo', className: cx('pager-img'), src: src }),
	        _react2.default.createElement('img', { alt: 'foo', className: cx('pager-copy-img'), src: copies[i] })
	      );
	    };
	
	    _this.prev = function () {
	      var currentView = _this.state.currentView;
	
	
	      _this.stopInterval();
	
	      _this.setState({
	        currentView: currentView > 0 ? currentView - 1 : banners.length - 1
	      });
	    };
	
	    _this.next = function () {
	      var currentView = _this.state.currentView;
	
	
	      _this.stopInterval();
	
	      _this.setState({
	        currentView: (currentView + 1) % banners.length
	      });
	    };
	
	    _this.state = {
	      currentView: banners[0]
	    };
	    banners.forEach(function (src, index) {
	      _this['@@' + src] = function () {
	        this.setState({ currentView: index });
	      }.bind(_this);
	    });
	    return _this;
	  }
	
	  Carousel.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this._key = setInterval(function () {
	      var currentView = _this2.state.currentView;
	
	      if (typeof currentView === 'string') {
	        currentView = _lodash2.default.findIndex(banners, function (src) {
	          return src === currentView;
	        });
	      }
	      _this2.setState({
	        currentView: (currentView + 1) % banners.length
	      });
	    }, bannerTimeout);
	  };
	
	  Carousel.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.stopInterval();
	  };
	
	  Carousel.prototype.stopInterval = function stopInterval() {
	    if (this._key) {
	      clearInterval(this._key);
	    }
	  };
	
	  Carousel.prototype.render = function render() {
	    var _this3 = this;
	
	    var currentView = this.state.currentView;
	
	
	    return _react2.default.createElement(
	      _reactViewPager.ViewPager,
	      { className: cx('carousel') },
	      _react2.default.createElement(
	        _reactViewPager.Frame,
	        { ref: this.frameRef },
	        _react2.default.createElement(
	          _reactViewPager.Track,
	          {
	            currentView: currentView,
	            onScroll: this.handleScroll,
	            onViewChange: this.handleViewChange
	          },
	          banners.map(this._carouselItem)
	        ),
	        _react2.default.createElement('img', {
	          className: cx('carousel-left'),
	          src: _carouselLeft2.default,
	          onClick: this.prev
	        }),
	        _react2.default.createElement('img', {
	          className: cx('carousel-right'),
	          src: _carouselRight2.default,
	          onClick: this.next
	        }),
	        _react2.default.createElement(
	          'nav',
	          { className: cx('pager-nav') },
	          banners.map(function (src, index) {
	            return _react2.default.createElement(_ProgressPage2.default, {
	              className: cx('page'),
	              index: index,
	              key: src,
	              onClick: _this3['@@' + src]
	            });
	          })
	        )
	      )
	    );
	  };
	
	  return Carousel;
	}(_react.PureComponent);
	
	exports.default = Carousel;
	
	
	Carousel.displayName = 'Carousel';
	Carousel.propTypes = propTypes;
	module.exports = exports['default'];

/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Featured;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(3);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactLazyloadFadein = __webpack_require__(123);
	
	var _reactLazyloadFadein2 = _interopRequireDefault(_reactLazyloadFadein);
	
	var _homeModule = __webpack_require__(118);
	
	var _homeModule2 = _interopRequireDefault(_homeModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cx = _bind2.default.bind(_homeModule2.default);
	var propTypes = {
	  img: _propTypes2.default.string,
	  price: _propTypes2.default.number,
	  sale: _propTypes2.default.number,
	  title: _propTypes2.default.string
	};
	
	function Featured(_ref) {
	  var img = _ref.img,
	      title = _ref.title,
	      price = _ref.price,
	      sale = _ref.sale;
	
	  var isSale = !!sale;
	  var Price = isSale ? 'del' : 'span';
	  var _sale = isSale ? _react2.default.createElement(
	    'span',
	    { className: cx('sale') },
	    '$',
	    sale
	  ) : null;
	  return _react2.default.createElement(
	    _gatsbyLink2.default,
	    { className: cx('featured'), to: '/women/shoes' },
	    _react2.default.createElement(
	      'div',
	      { className: cx('img-container') },
	      _react2.default.createElement(
	        _reactLazyloadFadein2.default,
	        { height: 180 },
	        function (onLoad) {
	          return _react2.default.createElement('img', { className: cx('img'), src: img, onLoad: onLoad });
	        }
	      )
	    ),
	    _react2.default.createElement(
	      'header',
	      { className: cx('title') },
	      _react2.default.createElement(
	        'h4',
	        null,
	        title
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: cx('price') },
	      _react2.default.createElement(
	        Price,
	        null,
	        '$',
	        price
	      ),
	      ' ',
	      _sale
	    )
	  );
	}
	Featured.displayName = 'Featured';
	Featured.propTypes = propTypes;
	module.exports = exports['default'];

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bind = __webpack_require__(3);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _reactLazyloadFadein = __webpack_require__(123);
	
	var _reactLazyloadFadein2 = _interopRequireDefault(_reactLazyloadFadein);
	
	var _homeModule = __webpack_require__(118);
	
	var _homeModule2 = _interopRequireDefault(_homeModule);
	
	var _falcorFront = __webpack_require__(1132);
	
	var _falcorFront2 = _interopRequireDefault(_falcorFront);
	
	var _graphqlFront = __webpack_require__(1133);
	
	var _graphqlFront2 = _interopRequireDefault(_graphqlFront);
	
	var _reactFront = __webpack_require__(1134);
	
	var _reactFront2 = _interopRequireDefault(_reactFront);
	
	var _webpackFront = __webpack_require__(1138);
	
	var _webpackFront2 = _interopRequireDefault(_webpackFront);
	
	var _Carousel = __webpack_require__(520);
	
	var _Carousel2 = _interopRequireDefault(_Carousel);
	
	var _Subheader = __webpack_require__(524);
	
	var _Subheader2 = _interopRequireDefault(_Subheader);
	
	var _Callout = __webpack_require__(205);
	
	var _Callout2 = _interopRequireDefault(_Callout);
	
	var _Featured = __webpack_require__(521);
	
	var _Featured2 = _interopRequireDefault(_Featured);
	
	var _LearnMore = __webpack_require__(341);
	
	var _LearnMore2 = _interopRequireDefault(_LearnMore);
	
	var _callout = __webpack_require__(1126);
	
	var _callout2 = _interopRequireDefault(_callout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cx = _bind2.default.bind(_homeModule2.default);
	var propTypes = {};
	var featured = [{
	  img: _reactFront2.default,
	  price: 199.0,
	  title: 'React'
	}, {
	  img: _webpackFront2.default,
	  title: 'Webpack',
	  price: 299.0,
	  sale: 199.0
	}, {
	  img: _falcorFront2.default,
	  title: 'Falcor',
	  price: 299.0,
	  sale: 199.0
	}, {
	  img: _graphqlFront2.default,
	  title: 'Graphql',
	  price: 299.0
	}];
	
	var Home = function (_Component) {
	  _inherits(Home, _Component);
	
	  function Home() {
	    _classCallCheck(this, Home);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Home.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: cx('home') },
	      _react2.default.createElement(_Carousel2.default, null),
	      _react2.default.createElement(_Subheader2.default, null),
	      _react2.default.createElement(
	        'div',
	        { className: cx('content-container') },
	        _react2.default.createElement(
	          _Callout2.default,
	          { className: cx('callout') },
	          _react2.default.createElement(
	            'header',
	            { className: cx('copy') },
	            _react2.default.createElement(
	              'h1',
	              { className: cx('title') },
	              'Free & Open Source'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'JAM Commerce is completely free to use and modify as you like. Create your own version or fork it and contribute!'
	            ),
	            _react2.default.createElement(_LearnMore2.default, null)
	          ),
	          _react2.default.createElement(
	            _reactLazyloadFadein2.default,
	            { height: 344 },
	            function (onLoad) {
	              return _react2.default.createElement('img', { src: _callout2.default, className: cx('img'), onLoad: onLoad });
	            }
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: cx('featured-container') },
	          featured.map(function (featured) {
	            return _react2.default.createElement(_Featured2.default, _extends({ key: featured.title }, featured));
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: cx('prefooter') },
	        _react2.default.createElement(
	          'h4',
	          null,
	          'Learn More about the JAMstack from the links in the footer, or click around this example app to see how JAM Commerce works!'
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            className: cx('github-mobile-fork-button'),
	            href: 'https://github.com/realworldreact/jamcommerce'
	          },
	          'Fork me on GitHub'
	        )
	      )
	    );
	  };
	
	  return Home;
	}(_react.Component);
	
	exports.default = Home;
	
	Home.displayName = 'Home';
	Home.propTypes = propTypes;
	module.exports = exports['default'];

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = LearnMore;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bind = __webpack_require__(3);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _homeModule = __webpack_require__(118);
	
	var _homeModule2 = _interopRequireDefault(_homeModule);
	
	var _rightTriangle = __webpack_require__(1135);
	
	var _rightTriangle2 = _interopRequireDefault(_rightTriangle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cx = _bind2.default.bind(_homeModule2.default);
	var propTypes = {};
	
	function LearnMore() {
	  return _react2.default.createElement(
	    'a',
	    { className: cx('learn-more'), href: '/women/shoes' },
	    'Learn More',
	    _react2.default.createElement('img', { className: cx('triangle'), src: _rightTriangle2.default })
	  );
	}
	LearnMore.displayName = 'LearnMore';
	LearnMore.propTypes = propTypes;
	module.exports = exports['default'];

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = ProgressPage;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactViewPager = __webpack_require__(440);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  className: _propTypes2.default.string,
	  index: _propTypes2.default.number,
	  onClick: _propTypes2.default.func
	};
	
	var colors = ['#209D22', '#106CCC', '#C1146B', '#11BDBF', '#8A19EA'];
	
	function ProgressPage(_ref) {
	  var className = _ref.className,
	      index = _ref.index,
	      onClick = _ref.onClick;
	
	  return _react2.default.createElement(_reactViewPager.AnimatedView, {
	    animations: [{
	      prop: 'scale',
	      stops: [[-300, 0.75], [0, 1], [300, 0.75]]
	    }, {
	      prop: 'opacity',
	      stops: [[-300, 0.5], [0, 1], [300, 0.5]]
	    }, {
	      prop: 'backgroundColor',
	      stops: [[-300, '#cccccc'], [0, colors[index]], [300, '#cccccc']]
	    }],
	    className: className,
	    index: index,
	    key: index,
	    onClick: onClick
	  });
	}
	ProgressPage.displayName = 'ProgressPage';
	ProgressPage.propTypes = propTypes;
	module.exports = exports['default'];

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Subheader;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bind = __webpack_require__(3);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _reactLazyloadFadein = __webpack_require__(123);
	
	var _reactLazyloadFadein2 = _interopRequireDefault(_reactLazyloadFadein);
	
	var _homeModule = __webpack_require__(118);
	
	var _homeModule2 = _interopRequireDefault(_homeModule);
	
	var _subheader = __webpack_require__(1136);
	
	var _subheader2 = _interopRequireDefault(_subheader);
	
	var _subheader3 = __webpack_require__(1137);
	
	var _subheader4 = _interopRequireDefault(_subheader3);
	
	var _LearnMore = __webpack_require__(341);
	
	var _LearnMore2 = _interopRequireDefault(_LearnMore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cx = _bind2.default.bind(_homeModule2.default);
	var propTypes = {};
	
	function Subheader() {
	  return _react2.default.createElement(
	    'div',
	    { className: cx('subheader') },
	    _react2.default.createElement(
	      'div',
	      { className: cx('subheader-container') },
	      _react2.default.createElement(
	        _reactLazyloadFadein2.default,
	        { height: 400 },
	        function (onLoad) {
	          return _react2.default.createElement('img', { className: cx('img'), src: _subheader2.default, onLoad: onLoad });
	        }
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h2',
	          { className: cx('title') },
	          'Get up and running fast'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: cx('copy') },
	        'JAM Commerce has a minimal learning curve. If you know how to fetch an API and are familiar with Git, you can make your front-end code a full-stack e-commerce solution in record time.'
	      ),
	      _react2.default.createElement(_LearnMore2.default, null)
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: cx('subheader-container') },
	      _react2.default.createElement(
	        _reactLazyloadFadein2.default,
	        { height: 400 },
	        function (onLoad) {
	          return _react2.default.createElement('img', { className: cx('img'), src: _subheader4.default, onLoad: onLoad });
	        }
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h2',
	          { className: cx('title') },
	          'Use tech that you love'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: cx('copy') },
	        'JAM Commerce is headless, meaning you can use whatever front-end you\'d like. You can also update and modify your stack by simply reconnecting the API endpoints. For this example app, we used the Gatsby static-site generator and some cool other tools.'
	      ),
	      _react2.default.createElement(_LearnMore2.default, null)
	    )
	  );
	}
	Subheader.displayName = 'Subheader';
	Subheader.propTypes = propTypes;
	module.exports = exports['default'];

/***/ }),

/***/ 1123:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/banner-1.78da3e11.png";

/***/ }),

/***/ 1124:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/banner-2.2eb73cea.png";

/***/ }),

/***/ 1125:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/banner-3.ccbc3482.png";

/***/ }),

/***/ 1126:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/callout.a5fbad3f.png";

/***/ }),

/***/ 1127:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAA6CAYAAAE/yLIqAAAAAXNSR0IArs4c6QAAAgtJREFUWAntmN9tgzAQxgHBDh2hfzbgIVLUgSr1rQ+0SobpHiRSRqi6QdMsQe8QZwHx2T5jW41EpMiG8/f9vhibkGSZ6XU6ne5VnT9QQwJ1DofDXlk5HsD4ouu6Rumo07ZtR33VsidzNWTWwRhlWX7OTmcZFiZTQyPkBVJSq01JxXEbfuDYfdI3om6rSJ8LLtQv9dn2Zgcdj8cXdlWzHxcKuH5xR1VV9SAyGAvruv5GiJOBTkgJjQYmodHARag1kAgnBj5CMiiwg5ckz/MLzSwVxS1uVkhjX/o259XINkNZFmSO4Go1xn3A5Rjuy2euzp5HIbx/2AFcYRVyMwPn18n5V5MDYQq4o35Aewdb7NEQTlvqtyQI3+HWvAOjp81m86UdqTmp9rOPgRKjsdRgIpYaXIklBlqxqwErdjEwim0GVrHJwEk8GDSwkPbjheQs1hmIxHMDsXhigAepXrD8+8dV5MHcvXoll4YdQ0F7hmflLT6YRYVzUAofBW6DRoG7QoPCpdAgcF/oIvhSqBc8FFQEDw11gseCGuGxoVp4KugEnhpK8BLA+KjX/9UI3zQXKDwv/jVO7pZW3duHEDscP4TYSp47LRxtWcGpmjLEFTxlCBaeIoQVHjOEMzxGCDE8ZAhveIgQi+FLQgSD+4QIDh+F6H9Y4TF3x4wGdwkRHW4KQbVkLXx3NPB+Q+AfBRKMncZXRU4AAAAASUVORK5CYII="

/***/ }),

/***/ 1128:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAA6CAYAAAE/yLIqAAAAAXNSR0IArs4c6QAAAf9JREFUWAntl2tKxDAUhaezB12E4BZmEy7CBQiCwoygP8S9uAWRttAFCLoHxyVMod5TmpK0ed00iQ+mMLR5nPud3DRpZrXSXWVZdrN6Y+Va7loUxddYrqpqry/UdX01tvy2B+1IdSYzdlRSKXvhN0BNqp0cZfqMOX12dUKUs/ydtlOzSnnw1HcqlBapgE5UvJCq1EfrzP6tRhpYgfF2XfdOq/Nus9ncq4N1l8ZEhgYaAwgWN9AsADeQMYBvIGcATaAdJftB1HsHEAIpR30gZaMVnWx3on9gQ6apZ085Fvfe+qabyEehKTNDPSWIPx2DFu/AZdC0CFNE/zwGOObgn70H7N0V6wE5oM3xlL2zNk1zDiHtrrcsMoSHw+ENQtqeH73FUyHse4l1Qi+xSegU24RWsUtoFPsItWJf4UzMESpirnAUhwh7cagQ4rX8rqKCc+HYeU2r5Ami0KMnByj37dcGGcA5/xVLFY25TCgLM7cJBS5SksuEFp7LhBWe2oQXPJUJFjy2iSB4LBOL4EtNRIFbTPR/+0T79B4VLoJr9gmtiSRwXxNJ4S4TWeAwge9227Yv9PE6QZl91oSIe+mgOKciTrKR26BiANHhPtDocA40GjwEuhi+BBoMjwFlw2NCveEpoE54SqgRngM6g+eEjvCfgAp4f6eP/5Z+N0plhsI3/86dBM/LhfMAAAAASUVORK5CYII="

/***/ }),

/***/ 1129:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/carousel-text-1.2abdfa8b.svg";

/***/ }),

/***/ 1130:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/carousel-text-2.a4a2a1ff.svg";

/***/ }),

/***/ 1131:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/carousel-text-3.74ab35b5.svg";

/***/ }),

/***/ 1132:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/falcor-front.19d1d705.png";

/***/ }),

/***/ 1133:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/graphql-front.d04d1c58.png";

/***/ }),

/***/ 118:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"carousel":"PvQUml-NlX6jpgqUMJ_B1","carousel-left":"_K9JjC9V4DCP0JLC6sAKo","carousel-right":"_2UgFQf9CLDvoy8T0z_ndvw","subheader":"dQq5vXyBnPJQo11eLfYbk","subheader-container":"l-QkJMCTLAOwoO7nBHIvo","img":"_2RPu56pGgBowpdnPzhxxC","copy":"_1cJS1sBgkiny_gF-I3Albg","learn-more":"_1sTGdUM4PvwbNNHdL8Jtuz","triangle":"y0B_Qnwg2iUE0-zo9r1kY","pager-nav":"_35gPM5WLWbnSzi75pRK9Cj","pager-container":"_3LF1cJC0fyoXwTNq1ooEA8","pager-img":"_2k35cR3wgp06R1ry8MA1vI","pager-copy-img":"_2E2QlAZX4PH3mUShAT0EZk","pager-copy-top":"_2dly6XEGh4lxxD1YqBfBPt","pager-copy-bottom":"_3gjVn-WpFXrBMPcPLpGISR","pager-hr":"mIOc7qoi0HaFC664dLf7B","pager-footer":"_1qnnBEQSPuVKMiXozn0Zi-","page":"OZtvYgvIMdqvL6sYHQroh","content-container":"_3ASYyUVmCG_SBa7LAHNGvG","callout":"_1lSAZVYes5BngnO-BZgiu_","title":"_3uyqUaV8dZLVeDsx6GGblu","featured-container":"_1dxvFRc65Pk3j19wkmIQCQ","featured":"_2EXqQvvX7ijo5Svf-cgwq_","sale":"_21cKZaQvJRdx2_V3migBJi","img-container":"_1rv1_1ztJGA8wZAfAND0SR","prefooter":"_1Jm_DdO0Ic9zyy5tTcZl0L","github-mobile-fork-button":"_1XkZgpEpB-yIFNyrtwQ8US"};

/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Home = __webpack_require__(522);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Home).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 1134:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/react-front.d8ef28f8.png";

/***/ }),

/***/ 1135:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjEycHgiIGhlaWdodD0iMTJweCIgdmlld0JveD0iMCAwIDEyIDEyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0My4yICgzOTA2OSkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+aWNvbnMvc21hbGwtcmlnaHQtYXJyb3c8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iTWFpbi1EZXNpZ24iIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJSRVNPVVJDRVMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01MzQuMDAwMDAwLCAtOTkuMDAwMDAwKSIgZmlsbD0iIzAwMDAwMCI+CiAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJpY29ucy9zbWFsbC1yaWdodC1hcnJvdyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTQwLjAwMDAwMCwgMTA1LjAwMDAwMCkgcm90YXRlKDkwLjAwMDAwMCkgdHJhbnNsYXRlKC01NDAuMDAwMDAwLCAtMTA1LjAwMDAwMCkgIiBwb2ludHM9IjU0MCA5OSA1NDYgMTExIDUzNCAxMTEiPjwvcG9seWdvbj4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),

/***/ 1136:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/subheader-1.8ce08105.png";

/***/ }),

/***/ 1137:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/subheader-2.5f698d17.png";

/***/ }),

/***/ 1138:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/webpack-front.98811a8c.png";

/***/ }),

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Home = __webpack_require__(525);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Home).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-jsx-32b3b72a3b7947a15c22.js